/**
 * DEV NOTES from Scales Items Spreadsheet
 * INCLUDE- 9c69da84-9168-452e-8d06-ff76966ddec5 | Formless Input – Part 1 Scale Values Only
 *      'scored items'
 * INCLUDE- fa527c3b-efc4-4053-9749-e55e2051a29b | Formless Input – Part 1 Unscored Items
 *      'notes and sub questions for Part 1 Scale Values'
 * ""
 * - cd820c34-a329-48f3-aa6d-31d23e0d8ada | Formless Input - Offender History
 *      'non required questions/answers, just data for offender history'
 * ""
 * INCLUDE- c4458a9a-a276-4a35-a850-ef6d8e3390f5 | Formless Input –Parts 2 to 7
 *      'no required questions/answers, parts 2-7'
 * ""
 * IGNORE d59457148c314619965c413fb77c3873 | Formless Input – Section 1 Scale Values Only
 *      'seems to be the LSI-R section 1'
 * ""
 * On full LSCMI Example, 124>125>133>Q-I1ajg4kp7>A-OScj6LtAmj pertains to filling out
 *  info in parts 2-7 without message notifications
 */

/** ... */
const evaluationForm: DataGatherer.Form = {
  type: 'evaluation',
  id: '9c69da84-9168-452e-8d06-ff76966ddec5',
  interpretAs: '9c69da84-9168-452e-8d06-ff76966ddec5',
  sourceId: '9c69da84-9168-452e-8d06-ff76966ddec5',
  name: 'LS/CMI',
  rules: [
    {
      type: 'Omit',
      amount: 4,
      omitValue: '-1',
      ruleText: 'You may omit a maximum of 4 items.',
    },
  ],
  fields: [
    {
      type: 'field-group',
      heading: '1.1 Criminal History',
      fields: [
        {
          id: '9Zr9qRVK',
          referenceId: '1.1.1',
          label: 'Any prior youth dispositions or adult convictions?',
          sequenceNumber: 1,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          subFields: [
            {
              id: 'USWgy4T8',
              referenceId: '',
              label: 'Number of prior youth dispositions',
              sequenceNumber: 1,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'text',
              payloadType: 'unscoredValues',
              hideSequenceNumber: true,
            },
            {
              id: 'yPKQ1kmS',
              referenceId: '',
              label: 'Number of prior adult convictions',
              sequenceNumber: 2,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'text',
              payloadType: 'unscoredValues',
              hideSequenceNumber: true,
            },
          ],
          displayNumberOverride: '1',
        },
        {
          id: 'ZyeoyVp1',
          referenceId: '1.1.2',
          label: 'Two or more prior youth/adult dispositions/convictions?',
          sequenceNumber: 2,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>9Zr9qRVK>1'],
                  message:
                    'If item {2} is answered "{Yes}", then item {1} must also be answered "{Yes}." We have already made this adjustment for you. Please see the LS/CMI scoring guide for more details.',
                  conditions: [],
                },
              ],
            },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '2',
        },
        {
          id: 'X03jK9Ti',
          referenceId: '1.1.3',
          label: 'Three or more prior youth/adult dispositions/convictions?',
          sequenceNumber: 3,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: [
                    '9c69da84-9168-452e-8d06-ff76966ddec5>9Zr9qRVK>1',
                    '9c69da84-9168-452e-8d06-ff76966ddec5>ZyeoyVp1>1',
                  ],
                  message:
                    'If item {3} is answered "{Yes}", then items {1} and {2} must also be answered "{Yes}." We have already made this adjustment for you. Please see the LS/CMI scoring guide for more details.',
                  conditions: [],
                },
              ],
            },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '3',
        },
        {
          id: 'vVUvpgUT',
          referenceId: '1.1.4',
          label: 'Three or more present offences?',
          sequenceNumber: 4,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          subFields: [
            {
              id: 'bsKLdZok',
              referenceId: '',
              label: 'Number of present offences',
              sequenceNumber: 3,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'text',
              payloadType: 'unscoredValues',
              hideSequenceNumber: true,
            },
          ],
          displayNumberOverride: '4',
        },
        {
          id: '1h0VTbye',
          referenceId: '1.1.5',
          label: 'Arrested or charged under age 16?',
          sequenceNumber: 5,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>vvoG65BU>1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '5',
        },
        {
          id: 'U4nxrOep',
          referenceId: '1.1.6',
          label: 'Ever incarcerated upon conviction?',
          sequenceNumber: 6,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '6',
        },
        {
          id: 'ZNg14HXv',
          referenceId: '1.1.7',
          label:
            'Ever punished for institutional misconduct or a behavior report?',
          sequenceNumber: 7,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          subFields: [
            {
              id: 'O6KaDHFQ',
              referenceId: '',
              label: 'Number of times punished for institutional misconduct',
              sequenceNumber: 4,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'text',
              payloadType: 'unscoredValues',
              hideSequenceNumber: true,
            },
          ],
          displayNumberOverride: '7',
        },
        {
          id: 'xRK3Wd1o',
          referenceId: '1.1.8',
          label:
            'Charge laid, probation breached, or parole suspended during prior community supervision?',
          sequenceNumber: 8,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>96KAK8op>1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: 'No',
              value: '0',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>96KAK8op>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: 'Omit',
              value: '-1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>96KAK8op>-1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
          ],
          displayNumberOverride: '8',
        },
        {
          id: 'cWmC0S6Z',
          referenceId: '1.1.1.1',
          label: 'Is this subcomponent considered to be a strength?',
          sequenceNumber: 9,
          hideSequenceNumber: true,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
          ],
        },
        {
          id: 'PtOeHie5',
          referenceId: '',
          label: '1.1 Criminal History. Reason/Notes on strength',
          sequenceNumber: 5,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
        {
          id: 'sMlq3HpG',
          referenceId: '',
          label: '1.1 Criminal History. Notes',
          sequenceNumber: 6,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
      ],
    },
    {
      type: 'field-group',
      heading: '1.2 Education/Employment',
      fields: [
        {
          id: 'J25fLwCn',
          referenceId: '1.2.9',
          label: 'Currently unemployed?',
          sequenceNumber: 10,
          displayNumberOverride: '9',
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: [
                    '9c69da84-9168-452e-8d06-ff76966ddec5>9H4W7xRM>0',
                    '9c69da84-9168-452e-8d06-ff76966ddec5>4Gqd1ToK>0',
                    '9c69da84-9168-452e-8d06-ff76966ddec5>H2PFlzTO>0',
                  ],
                  message:
                    'If item {9} is answered "{Yes}", then items {15}, {16} and {17} must be answered "{0}." We have already made this adjustment for you. Please see LS/CMI scoring guide for more details',
                  conditions: [],
                },
              ],
            },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
        },
        {
          id: 'eov7CMUi',
          referenceId: '1.2.10',
          label: 'Frequently unemployed?',
          sequenceNumber: 11,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '10',
        },
        {
          id: 'kJVip90R',
          referenceId: '1.2.11',
          label: 'Never employed for a full year?',
          sequenceNumber: 12,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>wq434X8w>1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: 'No',
              value: '0',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>wq434X8w>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: 'Omit',
              value: '-1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>wq434X8w>-1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
          ],
          displayNumberOverride: '11',
        },
        {
          id: 'zuvRLJpC',
          referenceId: '1.2.12',
          label: 'Less than regular grade 10 or equivalent?',
          sequenceNumber: 13,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>j0kjzk6A>1'],
                  message:
                    'If item {12} is answered "{Yes}", then item {13} must also be answered "{Yes}." We have already made this adjustment for you. Please see the LS/CMI scoring guide for more details.',
                  conditions: [],
                },
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>3YHH5ofl>1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: 'No',
              value: '0',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>3YHH5ofl>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: 'Omit',
              value: '-1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>3YHH5ofl>-1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
          ],
          displayNumberOverride: '12',
        },
        {
          id: 'j0kjzk6A',
          referenceId: '1.2.13',
          label: 'Less than regular grade 12 or equivalent?',
          sequenceNumber: 14,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '13',
        },
        {
          id: '8kMWAz4z',
          referenceId: '1.2.14',
          label: 'Suspended or expelled at least once.',
          sequenceNumber: 15,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>5TxjT7U7>1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: 'No',
              value: '0',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>5TxjT7U7>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: 'Omit',
              value: '-1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>5TxjT7U7>-1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
          ],
          displayNumberOverride: '14',
        },
        {
          id: '9H4W7xRM',
          referenceId: '1.2.15',
          label: 'Participation/performance.',
          sequenceNumber: 16,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: '3', value: '3' },
            { label: '2', value: '2' },
            { label: '1', value: '1' },
            { label: '0', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '15',
        },
        {
          id: '4Gqd1ToK',
          referenceId: '1.2.16',
          label: 'Peer interactions.',
          sequenceNumber: 17,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: '3', value: '3' },
            { label: '2', value: '2' },
            { label: '1', value: '1' },
            { label: '0', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '16',
        },
        {
          id: 'H2PFlzTO',
          referenceId: '1.2.17',
          label: 'Authority interaction.',
          sequenceNumber: 18,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: '3', value: '3' },
            { label: '2', value: '2' },
            { label: '1', value: '1' },
            { label: '0', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '17',
        },
        {
          id: 'YpW4JumD',
          referenceId: '1.2.1.2',
          label: 'Is this subcomponent considered to be a strength?',
          sequenceNumber: 19,
          hideSequenceNumber: true,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
          ],
        },
        {
          id: 'S6LRSvlL',
          referenceId: '',
          label: '1.2 Education/Employment. Reason/Notes on strength',
          sequenceNumber: 7,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
        {
          id: '8jZ9WUCR',
          referenceId: '',
          label: '1.2 Education/Employment. Notes',
          sequenceNumber: 8,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
      ],
    },
    {
      type: 'field-group',
      heading: '1.3 Family/Marital',
      fields: [
        {
          id: 'YWLcOKIJ',
          referenceId: '1.3.18',
          label: 'Dissatisfaction with marital or equivalent situation.',
          sequenceNumber: 20,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: '3', value: '3' },
            { label: '2', value: '2' },
            { label: '1', value: '1' },
            { label: '0', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '18',
        },
        {
          id: 'os7DQhSA',
          referenceId: '1.3.19',
          label: 'Nonrewarding, parental.',
          sequenceNumber: 21,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: '3',
              value: '3',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: '2',
              value: '2',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: '1',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs>1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: '0',
              value: '0',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs>1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: 'Omit',
              value: '-1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs>-1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
          ],
          displayNumberOverride: '19',
        },
        {
          id: 'ILdmnJvj',
          referenceId: '1.3.20',
          label: 'Nonrewarding, other relatives.',
          sequenceNumber: 22,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: '3', value: '3' },
            { label: '2', value: '2' },
            { label: '1', value: '1' },
            { label: '0', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '20',
        },
        {
          id: 'yZY3Wyc3',
          referenceId: '1.3.21',
          label: 'Criminal-Family/spouse.',
          sequenceNumber: 23,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '21',
        },
        {
          id: 'E59jerUd',
          referenceId: '1.3.1.3',
          label: 'Is this subcomponent considered to be a strength?',
          sequenceNumber: 24,
          hideSequenceNumber: true,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
          ],
        },
        {
          id: 'RR5VNYUE',
          referenceId: '',
          label: '1.3 Family/Marital. Reason/Notes on strength',
          sequenceNumber: 9,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
        {
          id: 'iWRtvInn',
          referenceId: '',
          label: '1.3 Family/Marital. Notes',
          sequenceNumber: 10,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
      ],
    },
    {
      type: 'field-group',
      heading: '1.4 Leisure/Recreation',
      fields: [
        {
          id: 'xKhMyHaH',
          referenceId: '1.4.22',
          label: 'Absence of recent participation in an organized activity.',
          sequenceNumber: 25,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '22',
        },
        {
          id: '4ddmx8sc',
          referenceId: '1.4.23',
          label: 'Could make better use of time."',
          sequenceNumber: 26,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: '3', value: '3' },
            { label: '2', value: '2' },
            { label: '1', value: '1' },
            { label: '0', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '23',
        },
        {
          id: 'PjRurn5D',
          referenceId: '1.4.1.4',
          label: 'Is this subcomponent considered to be a strength?',
          sequenceNumber: 27,
          hideSequenceNumber: true,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
          ],
        },
        {
          id: 'D4Llw3mU',
          referenceId: '',
          label: '1.4 Leisure/Recreation. Reason/Notes on strength',
          sequenceNumber: 11,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
        {
          id: 'JCwOmw2h',
          referenceId: '',
          label: '1.4 Leisure/Recreation. Notes',
          sequenceNumber: 12,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
      ],
    },
    {
      type: 'field-group',
      heading: '1.5 Companions',
      fields: [
        {
          id: 'dsZjqchv',
          referenceId: '1.5.24',
          label: 'Some criminal acquaintances.',
          sequenceNumber: 28,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '24',
        },
        {
          id: 'at6yivCL',
          referenceId: '1.5.25',
          label: 'Some criminal friends.',
          sequenceNumber: 29,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: '3',
              value: '3',
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '||',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>at6yivCL',
                          comparator: '3',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>at6yivCL',
                          comparator: '2',
                        },
                      ],
                    },
                    {
                      operator: '=',
                      variable: 'c4458a9a-a276-4a35-a850-ef6d8e3390f5>leWXqtd4',
                      comparator: '1',
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If item {18} in section {2.2} is answered "{Yes}", then consider answering item {25} in section {1.5} as "{0}" or "{1}".',
                },
                {
                  conditions: [
                    {
                      operator: '||',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>at6yivCL',
                          comparator: '3',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>at6yivCL',
                          comparator: '2',
                        },
                      ],
                    },
                    {
                      operator: '=',
                      variable: 'c4458a9a-a276-4a35-a850-ef6d8e3390f5>JKhpRAbJ',
                      comparator: '1',
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If item {19} in section {2.2} is answered "{Yes}", then consider answering item {25} in section {1.5} as "{0}" or "{1}".',
                },
              ],
            },
            {
              label: '2',
              value: '2',
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '||',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>at6yivCL',
                          comparator: '3',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>at6yivCL',
                          comparator: '2',
                        },
                      ],
                    },
                    {
                      operator: '=',
                      variable: 'c4458a9a-a276-4a35-a850-ef6d8e3390f5>leWXqtd4',
                      comparator: '1',
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If item {18} in section {2.2} is answered "{Yes}", then consider answering item {25} in section {1.5} as "{0}" or "{1}".',
                },
                {
                  conditions: [
                    {
                      operator: '||',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>at6yivCL',
                          comparator: '3',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>at6yivCL',
                          comparator: '2',
                        },
                      ],
                    },
                    {
                      operator: '=',
                      variable: 'c4458a9a-a276-4a35-a850-ef6d8e3390f5>JKhpRAbJ',
                      comparator: '1',
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If item {19} in section {2.2} is answered "{Yes}", then consider answering item {25} in section {1.5} as "{0}" or "{1}".',
                },
              ],
            },
            {
              label: '1',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>dsZjqchv>1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: '0',
              value: '0',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>dsZjqchv>1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '25',
        },
        {
          id: 'pxikMzhr',
          referenceId: '1.5.26',
          label: 'Few anticriminal acquaintances.',
          sequenceNumber: 30,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: 'Yes',
              value: '1',
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '&&',
                      conditions: [
                        {
                          operator: '!=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>OlzADRDx',
                          comparator: '0',
                        },
                        {
                          operator: '!=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>OlzADRDx',
                          comparator: '1',
                        },
                      ],
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If item {26} in section {1.5} is answered "{Yes}", then consider answering item {27} in section {1.5} as "{0}" or "{1}"',
                },
              ],
            },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '26',
        },
        {
          id: 'OlzADRDx',
          referenceId: '1.5.27',
          label: 'Few anticriminal friends.',
          sequenceNumber: 31,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: '3',
              value: '3',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: '2',
              value: '2',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: '1',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ>1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: '0',
              value: '0',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ>1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: 'Omit',
              value: '-1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ>-1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
          ],
          displayNumberOverride: '27',
        },
        {
          id: 'bX4hsYVE',
          referenceId: '1.5.1.5',
          label: 'Is this subcomponent considered to be a strength?',
          sequenceNumber: 32,
          hideSequenceNumber: true,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
          ],
        },
        {
          id: 'bNXvdf8X',
          referenceId: '',
          label: '1.5 Companions. Reason/Notes on strength',
          sequenceNumber: 13,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
        {
          id: 'M53YF8xe',
          referenceId: '',
          label: '1.5 Companions. Notes',
          sequenceNumber: 14,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
      ],
    },
    {
      type: 'field-group',
      heading: '1.6 Alcohol/Drug Problem',
      fields: [
        {
          id: 'SZI7JzY6',
          referenceId: '1.6.28',
          label: 'Alcohol problem, ever.',
          sequenceNumber: 33,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '28',
        },
        {
          id: 'L62kviCO',
          referenceId: '1.6.29',
          label: 'Drug problem, ever.',
          sequenceNumber: 34,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '29',
        },
        {
          id: 'xSsCFDwV',
          referenceId: '1.6.30',
          label: 'Alcohol problem, currently.',
          sequenceNumber: 35,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: '3',
              value: '3',
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '||',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>HPh8PK0H',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>Sb4WDqTX',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>G87p2sfO',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>qmgu6Xnd',
                          comparator: '1',
                        },
                      ],
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If at least one of items {32}, {33}, {34}, or {35} in section {1.6} is answered "{Yes}", then consider answering item {30} in section {1.6} as "{0}" or "{1}"',
                },
              ],
            },
            {
              label: '2',
              value: '2',
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '||',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>HPh8PK0H',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>Sb4WDqTX',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>G87p2sfO',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>qmgu6Xnd',
                          comparator: '1',
                        },
                      ],
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If at least one of items {32}, {33}, {34}, or {35} in section {1.6} is answered "{Yes}", then consider answering item {30} in section {1.6} as "{0}" or "{1}"',
                },
              ],
            },
            {
              label: '1',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>SZI7JzY6>1'],
                  message:
                    'If item {30} in section {1.6} is answered "{0}" or "{1}", then item {28} in section {1.6} must be answered "{Yes}." We have already made this adjustment for you. Please see LS/CMI scoring guide for more details',
                  conditions: [],
                },
              ],
            },
            {
              label: '0',
              value: '0',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>SZI7JzY6>1'],
                  message:
                    'If item {30} in section {1.6} is answered "{0}" or "{1}", then item {28} in section {1.6} must be answered "{Yes}." We have already made this adjustment for you. Please see LS/CMI scoring guide for more details',
                  conditions: [],
                },
              ],
            },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '30',
        },
        {
          id: 'qqK2spOl',
          referenceId: '1.6.31',
          label: 'Drug problem, currently.',
          sequenceNumber: 36,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: '3',
              value: '3',
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '||',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>HPh8PK0H',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>Sb4WDqTX',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>G87p2sfO',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>qmgu6Xnd',
                          comparator: '1',
                        },
                      ],
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If at least one of items {32}, {33}, {34}, or {35} in section {1.6} is answered "{Yes}", then consider answering item {31} in section {1.6} as "{0}" or "{1}"',
                },
              ],
            },
            {
              label: '2',
              value: '2',
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '||',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>HPh8PK0H',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>Sb4WDqTX',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>G87p2sfO',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>qmgu6Xnd',
                          comparator: '1',
                        },
                      ],
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If at least one of items {32}, {33}, {34}, or {35} in section {1.6} is answered "{Yes}", then consider answering item {30} in section {1.6} as "{0}" or "{1}"',
                },
              ],
            },
            {
              label: '1',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>L62kviCO>1'],
                  message:
                    'If item {31} in section {1.6} is answered "{0}" or "{1}", then item {29} in section {1.6} must be answered "{Yes}." We have already made this adjustment for you. Please see LS/CMI scoring guide for more details',
                  conditions: [],
                },
              ],
            },
            {
              label: '0',
              value: '0',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>L62kviCO>1'],
                  message:
                    'If item {31} in section {1.6} is answered "{0}" or "{1}", then item {29} in section {1.6} must be answered "{Yes}." We have already made this adjustment for you. Please see LS/CMI scoring guide for more details',
                  conditions: [],
                },
              ],
            },
            { label: 'Omit', value: '-1' },
          ],
          subFields: [
            {
              id: 'm8IEoDTy',
              referenceId: '',
              label: 'Specify type of drug(s)',
              sequenceNumber: 15,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'text',
              payloadType: 'unscoredValues',
              hideSequenceNumber: true,
            },
          ],
          displayNumberOverride: '31',
        },
        {
          id: 'HPh8PK0H',
          referenceId: '1.6.32',
          label: 'Law violations.',
          sequenceNumber: 37,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '32',
        },
        {
          id: 'Sb4WDqTX',
          referenceId: '1.6.33',
          label: 'Marital/Family.',
          sequenceNumber: 38,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '33',
        },
        {
          id: 'G87p2sfO',
          referenceId: '1.6.34',
          label: 'School/Work.',
          sequenceNumber: 39,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '34',
        },
        {
          id: 'qmgu6Xnd',
          referenceId: '1.6.35',
          label: 'Medical or other clinical indicators?',
          sequenceNumber: 40,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          subFields: [
            {
              id: 'rBuA7p74',
              referenceId: '',
              label: 'Medical or other clinical indicators? (specify):',
              sequenceNumber: 16,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'text',
              payloadType: 'unscoredValues',
              hideSequenceNumber: true,
            },
          ],
          displayNumberOverride: '35',
        },
        {
          id: 'cetJitx3',
          referenceId: '1.6.1.6',
          label: 'Is this subcomponent considered to be a strength?',
          sequenceNumber: 41,
          hideSequenceNumber: true,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
          ],
        },
        {
          id: 'HbXPjjN3',
          referenceId: '',
          label: '1.6 Alcohol/Drug Problem. Reason/Notes on strength',
          sequenceNumber: 17,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
        {
          id: 'tMyPTJqN',
          referenceId: '',
          label: '1.6 Alcohol/Drug Problem. Notes',
          sequenceNumber: 18,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
      ],
    },
    {
      type: 'field-group',
      heading: '1.7 Procriminal Attitude/Orientation',
      fields: [
        {
          id: 'Kw41PBKH',
          referenceId: '1.7.36',
          label: 'Supportive of crime.',
          sequenceNumber: 42,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: '3',
              value: '3',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>6tdEGtMv>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: '2',
              value: '2',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>6tdEGtMv>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: '1',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>6tdEGtMv>1'],
                  message: '',
                  conditions: [],
                },
              ],
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '=',
                      variable: '9c69da84-9168-452e-8d06-ff76966ddec5>Gg2c9jJO',
                      comparator: '1',
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If the strength question for section {1.7} Procriminal Attitude/Orientation is answered "{Yes}", then consider answering item {36} in section {1.7} as "{2}" or "{3}".',
                },
              ],
            },
            {
              label: '0',
              value: '0',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>6tdEGtMv>1'],
                  message: '',
                  conditions: [],
                },
              ],
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '=',
                      variable: '9c69da84-9168-452e-8d06-ff76966ddec5>Gg2c9jJO',
                      comparator: '1',
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If the strength question for section {1.7} Procriminal Attitude/Orientation is answered "{Yes}", then consider answering item {36} in section {1.7} as "{2}" or "{3}".',
                },
              ],
            },
            {
              label: 'Omit',
              value: '-1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>6tdEGtMv>-1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
          ],
          displayNumberOverride: '36',
        },
        {
          id: 'NFaXcGNV',
          referenceId: '1.7.37',
          label: 'Unfavorable toward convention.',
          sequenceNumber: 43,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: '3',
              value: '3',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>37Sek2tZ>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: '2',
              value: '2',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>37Sek2tZ>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: '1',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>37Sek2tZ>1'],
                  message: '',
                  conditions: [],
                },
              ],
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '=',
                      variable: '9c69da84-9168-452e-8d06-ff76966ddec5>Gg2c9jJO',
                      comparator: '1',
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If the strength question for section {1.7} Procriminal Attitude/Orientation is answered "{Yes}", then consider answering item {37} in section {1.7} as "{2}" or "{3}".',
                },
              ],
            },
            {
              label: '0',
              value: '0',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>37Sek2tZ>1'],
                  message: '',
                  conditions: [],
                },
              ],
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '=',
                      variable: '9c69da84-9168-452e-8d06-ff76966ddec5>Gg2c9jJO',
                      comparator: '1',
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If the strength question for section {1.7} Procriminal Attitude/Orientation is answered "{Yes}", then consider answering item {37} in section {1.7} as "{2}" or "{3}".',
                },
              ],
            },
            {
              label: 'Omit',
              value: '-1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>37Sek2tZ>-1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
          ],
          displayNumberOverride: '37',
        },
        {
          id: 'xjnruaCY',
          referenceId: '1.7.38',
          label: 'Poor, toward sentence/offence.',
          sequenceNumber: 44,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: 'Yes',
              value: '1',
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '=',
                      variable: '9c69da84-9168-452e-8d06-ff76966ddec5>Gg2c9jJO',
                      comparator: '1',
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If the strength question for section {1.7} Procriminal Attitude/Orientation is answered "{Yes}", then consider answering item {38} in section {1.7} as "{No}".',
                },
              ],
            },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '38',
        },
        {
          id: 'cu8gPYWX',
          referenceId: '1.7.39',
          label: 'Poor, toward supervision/treatment.',
          sequenceNumber: 45,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>2pQT45B1>1'],
                  message: '',
                  conditions: [],
                },
              ],
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '=',
                      variable: '9c69da84-9168-452e-8d06-ff76966ddec5>Gg2c9jJO',
                      comparator: '1',
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If the strength question for section {1.7} Procriminal Attitude/Orientation is answered "{Yes}", then consider answering item {38} in section {1.7} as "{No}".',
                },
              ],
            },
            {
              label: 'No',
              value: '0',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>2pQT45B1>0'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            {
              label: 'Omit',
              value: '-1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>2pQT45B1>-1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
          ],
          displayNumberOverride: '39',
        },
        {
          id: 'Gg2c9jJO',
          referenceId: '1.7.1.7',
          label: 'Is this subcomponent considered to be a strength?',
          sequenceNumber: 46,
          hideSequenceNumber: true,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
          ],
        },
        {
          id: 'tMS2eJ6e',
          referenceId: '',
          label:
            '1.7 Procriminal Attitude/Orientation. Reason/Notes on strength',
          sequenceNumber: 19,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
        {
          id: '2I8F0kev',
          referenceId: '',
          label: '1.7 Procriminal Attitude/Orientation. Notes',
          sequenceNumber: 20,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
      ],
    },
    {
      type: 'field-group',
      heading: '1.8 Antisocial Pattern',
      fields: [
        {
          id: 'HACP9ieH',
          referenceId: '1.8.40',
          label: 'Specialized assessment for antisocial pattern.',
          sequenceNumber: 47,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            {
              label: 'No',
              value: '0',
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '||',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>HACP9ieH',
                          comparator: '0',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>HACP9ieH',
                          comparator: '-1',
                        },
                      ],
                    },
                    {
                      operator: '=',
                      variable: 'c4458a9a-a276-4a35-a850-ef6d8e3390f5>1ncZjTBi',
                      comparator: '1',
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If item {79} in section {5} is answered "{Yes}", then consider answering item {40} in section {1.8} as "{Yes}".',
                },
              ],
            },
            {
              label: 'Omit',
              value: '-1',
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '||',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>HACP9ieH',
                          comparator: '0',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>HACP9ieH',
                          comparator: '-1',
                        },
                      ],
                    },
                    {
                      operator: '=',
                      variable: 'c4458a9a-a276-4a35-a850-ef6d8e3390f5>1ncZjTBi',
                      comparator: '1',
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If item {79} in section {5} is answered "{Yes}", then consider answering item {40} in section {1.8} as "{Yes}".',
                },
              ],
            },
          ],
          displayNumberOverride: '40',
        },
        {
          id: 'nSxDPHQg',
          referenceId: '1.8.41',
          label:
            'Early and diverse antisocial behavior. Item a, plus at least one of b, c, or d. Indicate all that apply.',
          sequenceNumber: 48,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          subFields: [
            {
              id: 'vvoG65BU',
              referenceId: '1.8.41a',
              label:
                'Severe problems of adjustment in childhood, as indicated by school and social welfare records, or arrested or charged under age 16.',
              sequenceNumber: 21,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>nSxDPHQg>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '||',
                          conditions: [
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>LEks992z',
                              comparator: '1',
                            },
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>p3WFGI1s',
                              comparator: '1',
                            },
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>96KAK8op',
                              comparator: '1',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'a',
              ignoreOmit: true,
            },
            {
              id: 'LEks992z',
              referenceId: '1.8.41b',
              label: 'Official record of assault/violence.',
              sequenceNumber: 22,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>nSxDPHQg>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>vvoG65BU',
                          comparator: '1',
                        },
                      ],
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'b',
              ignoreOmit: true,
            },
            {
              id: 'p3WFGI1s',
              referenceId: '1.8.41c',
              label:
                'Escape history from a correctional facility, unlawfully-at-large.',
              sequenceNumber: 23,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>nSxDPHQg>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>vvoG65BU',
                          comparator: '1',
                        },
                      ],
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'c',
              ignoreOmit: true,
            },
            {
              id: '96KAK8op',
              referenceId: '1.8.41d',
              label:
                'Charge laid, probation breached, or parole suspended during prior community supervision.',
              sequenceNumber: 24,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>nSxDPHQg>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>vvoG65BU',
                          comparator: '1',
                        },
                      ],
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'd',
              ignoreOmit: true,
            },
          ],
          displayNumberOverride: '41',
        },
        {
          id: 'RUd5gztN',
          referenceId: '1.8.42',
          label:
            'Criminal attitude. At least one of the following items. Indicate all that apply.',
          sequenceNumber: 49,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          subFields: [
            {
              id: '6tdEGtMv',
              referenceId: '1.8.42a',
              label: 'Supportive of crime.',
              sequenceNumber: 25,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>RUd5gztN>1',
                      ],
                      message: '',
                      conditions: [],
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'a',
              ignoreOmit: true,
            },
            {
              id: '37Sek2tZ',
              referenceId: '1.8.42b',
              label: 'Unfavorable toward convention.',
              sequenceNumber: 26,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>RUd5gztN>1',
                      ],
                      message: '',
                      conditions: [],
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'b',
              ignoreOmit: true,
            },
            {
              id: '2pQT45B1',
              referenceId: '1.8.42c',
              label: 'Poor, toward supervision/treatment.',
              sequenceNumber: 27,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>RUd5gztN>1',
                      ],
                      message: '',
                      conditions: [],
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'c',
              ignoreOmit: true,
            },
          ],
          displayNumberOverride: '42',
        },
        {
          id: '9TsNc1jf',
          referenceId: '1.8.43',
          label:
            'Pattern of generalized trouble. At least four of the following items. Indicate all that apply.',
          sequenceNumber: 50,
          required: true,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          subFields: [
            {
              id: 'zAKRZ0Y5',
              referenceId: '1.8.43a',
              label: 'Financial problems.',
              sequenceNumber: 28,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                { label: '3', value: '3' },
                { label: '2', value: '2' },
                {
                  label: '1',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>9TsNc1jf>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>IKfJvbTH',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>wq434X8w',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>3YHH5ofl',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>5TxjT7U7',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>B531H6w0',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ',
                          comparator: '1',
                        },
                      ],
                      conditionModifier: 'atLeast:3',
                    },
                  ],
                },
                {
                  label: '0',
                  value: '0',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>9TsNc1jf>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>IKfJvbTH',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>wq434X8w',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>3YHH5ofl',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>5TxjT7U7',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>B531H6w0',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ',
                          comparator: '1',
                        },
                      ],
                      conditionModifier: 'atLeast:3',
                    },
                  ],
                },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'a',
              ignoreOmit: true,
            },
            {
              id: 'IKfJvbTH',
              referenceId: '1.8.43b',
              label: '3 or more address changes last year.',
              sequenceNumber: 29,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>9TsNc1jf>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '||',
                          conditions: [
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '1',
                            },
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '0',
                            },
                          ],
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>wq434X8w',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>3YHH5ofl',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>5TxjT7U7',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>B531H6w0',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ',
                          comparator: '1',
                        },
                      ],
                      conditionModifier: 'atLeast:3',
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'b',
              ignoreOmit: true,
            },
            {
              id: 'CdfvU9lK',
              referenceId: '',
              label: 'Number of address changes last year',
              sequenceNumber: 30,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'text',
              payloadType: 'unscoredValues',
              hideSequenceNumber: true,
            },
            {
              id: 'wq434X8w',
              referenceId: '1.8.43c',
              label: 'Never employed for a full year.',
              sequenceNumber: 31,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>9TsNc1jf>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '||',
                          conditions: [
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '1',
                            },
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '0',
                            },
                          ],
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>IKfJvbTH',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>3YHH5ofl',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>5TxjT7U7',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>B531H6w0',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ',
                          comparator: '1',
                        },
                      ],
                      conditionModifier: 'atLeast:3',
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'c',
              ignoreOmit: true,
            },
            {
              id: '3YHH5ofl',
              referenceId: '1.8.43d',
              label: 'Less than regular grade 10 or equivalent.',
              sequenceNumber: 32,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>9TsNc1jf>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '||',
                          conditions: [
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '1',
                            },
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '0',
                            },
                          ],
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>IKfJvbTH',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>wq434X8w',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>5TxjT7U7',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>B531H6w0',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ',
                          comparator: '1',
                        },
                      ],
                      conditionModifier: 'atLeast:3',
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'd',
              ignoreOmit: true,
            },
            {
              id: '5TxjT7U7',
              referenceId: '1.8.43e',
              label: 'Suspended or expelled at least once.',
              sequenceNumber: 33,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>9TsNc1jf>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '||',
                          conditions: [
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '1',
                            },
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '0',
                            },
                          ],
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>IKfJvbTH',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>wq434X8w',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>3YHH5ofl',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>B531H6w0',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ',
                          comparator: '1',
                        },
                      ],
                      conditionModifier: 'atLeast:3',
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'e',
              ignoreOmit: true,
            },
            {
              id: 'iFjtBXIs',
              referenceId: '1.8.43f',
              label: 'Nonrewarding, parental.',
              sequenceNumber: 34,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>9TsNc1jf>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '||',
                          conditions: [
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '1',
                            },
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '0',
                            },
                          ],
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>IKfJvbTH',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>wq434X8w',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>3YHH5ofl',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>5TxjT7U7',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>B531H6w0',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ',
                          comparator: '1',
                        },
                      ],
                      conditionModifier: 'atLeast:3',
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'f',
              ignoreOmit: true,
            },
            {
              id: 'B531H6w0',
              referenceId: '1.8.43g',
              label: 'Could make better use of time.',
              sequenceNumber: 35,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>9TsNc1jf>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '||',
                          conditions: [
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '1',
                            },
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '0',
                            },
                          ],
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>IKfJvbTH',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>wq434X8w',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>3YHH5ofl',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>5TxjT7U7',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>mgEHmvyJ',
                          comparator: '1',
                        },
                      ],
                      conditionModifier: 'atLeast:3',
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'g',
              ignoreOmit: true,
            },
            {
              id: 'mgEHmvyJ',
              referenceId: '1.8.43h',
              label: 'Few anticriminal friends.',
              sequenceNumber: 36,
              required: false,
              model: { type: '', payloadLocation: '' },
              type: 'dropdown',
              payloadType: 'unscoredValues',
              answers: [
                {
                  label: 'Yes',
                  value: '1',
                  autoAnswer: [
                    {
                      answer: [
                        '9c69da84-9168-452e-8d06-ff76966ddec5>9TsNc1jf>1',
                      ],
                      message: '',
                      conditions: [
                        {
                          operator: '||',
                          conditions: [
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '1',
                            },
                            {
                              operator: '=',
                              variable:
                                '9c69da84-9168-452e-8d06-ff76966ddec5>zAKRZ0Y5',
                              comparator: '0',
                            },
                          ],
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>IKfJvbTH',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>wq434X8w',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>3YHH5ofl',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>5TxjT7U7',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>iFjtBXIs',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>B531H6w0',
                          comparator: '1',
                        },
                      ],
                      conditionModifier: 'atLeast:3',
                    },
                  ],
                },
                { label: 'No', value: '0' },
                { label: 'Omit', value: '-1' },
              ],
              displayNumberOverride: 'h',
              ignoreOmit: true,
            },
          ],
          displayNumberOverride: '43',
        },
        {
          id: 'TZ4KKF4D',
          referenceId: '1.8.1.8',
          label: 'Is this subcomponent considered to be a strength?',
          sequenceNumber: 51,
          hideSequenceNumber: true,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'evaluate',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
          ],
        },
        {
          id: 'IlKB685W',
          referenceId: '',
          label: '1.8 Antisocial Pattern. Reason/Notes on strength',
          sequenceNumber: 37,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
        {
          id: 'RwilCt4r',
          referenceId: '',
          label: '1.8 Antisocial Pattern. Notes',
          sequenceNumber: 38,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'unscoredValues',
          hideSequenceNumber: true,
        },
      ],
    },
  ],
};

/** ... */
const generalInformationForm: DataGatherer.Form = {
  id: 'f52e5164-7ac9-4d69-8f2c-41b6e162891e',
  interpretAs: 'f52e5164-7ac9-4d69-8f2c-41b6e162891e',
  sourceId: 'f52e5164-7ac9-4d69-8f2c-41b6e162891e',
  name: 'General Information',
  type: 'unknown',
  fields: [
    {
      id: 'C1VmfJO5',
      referenceId: '',
      label: 'Name of Assessed',
      sequenceNumber: 1,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'offenderHistory',
      hideSequenceNumber: true,
    },
    {
      id: 'mQpp3rwl',
      referenceId: '',
      label: 'Gender',
      sequenceNumber: 2,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'dropdown',
      payloadType: 'offenderHistory',
      answers: [
        { label: 'Male', value: 0 },
        { label: 'Female', value: 1 },
      ],
      hideSequenceNumber: true,
    },
    {
      id: '5LeaGyO5',
      referenceId: '',
      label: 'Age',
      sequenceNumber: 3,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'number',
      payloadType: 'offenderHistory',
      hideSequenceNumber: true,
    },
    {
      id: 'bkoFXQ5d',
      referenceId: '',
      label: 'Date of Birth',
      sequenceNumber: 4,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'date',
      payloadType: 'offenderHistory',
      hideSequenceNumber: true,
    },
    {
      id: 'RmvQPVkj',
      referenceId: '',
      label: 'Identifying Number',
      sequenceNumber: 5,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'unscoredValues',
      hideSequenceNumber: true,
    },
    {
      id: 'TCDMhBHU',
      referenceId: '',
      label: 'Interviewer',
      sequenceNumber: 6,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'offenderHistory',
      hideSequenceNumber: true,
    },
    {
      id: 'mjv6Gz4B',
      referenceId: '',
      label: 'Date of Test Administration / Interview Date',
      sequenceNumber: 7,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'date',
      payloadType: 'offenderHistory',
      hideSequenceNumber: true,
    },
    {
      id: 'V9wcZarJ',
      referenceId: '',
      label: 'Reason for Assessment',
      sequenceNumber: 8,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'text',
      payloadType: 'offenderHistory',
      hideSequenceNumber: true,
    },
    {
      id: 'pqfT1IF7',
      referenceId: '',
      label: 'Setting',
      sequenceNumber: 104,
      required: false,
      model: { type: '', payloadLocation: '' },
      type: 'dropdown',
      payloadType: 'offenderHistory',
      answers: [
        { label: 'Community', value: 0 },
        { label: 'Custodial', value: 1 },
      ],
      hideSequenceNumber: true,
    },
  ],
};

/** ... */
const parts2To7Form: DataGatherer.Form = {
  id: 'c4458a9a-a276-4a35-a850-ef6d8e3390f5',
  interpretAs: 'c4458a9a-a276-4a35-a850-ef6d8e3390f5',
  sourceId: 'c4458a9a-a276-4a35-a850-ef6d8e3390f5',
  name: 'Section 2-7',
  type: 'unknown',
  fields: [
    {
      type: 'field-group',
      heading: '2.1 - Personal Problems with Criminogenic Potential',
      fields: [
        {
          id: '8CqISsT1',
          referenceId: '2.1.1',
          label: 'Clear problems of compliance (specific conditions).',
          sequenceNumber: 1,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '1',
        },
        {
          id: '6stgM0XE',
          referenceId: '2.1.2',
          label: 'Diagnosis of "psychopathy."',
          sequenceNumber: 2,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '2',
        },
        {
          id: 'JXrE83i3',
          referenceId: '2.1.3',
          label: 'Diagnosis of other personality disorder.',
          sequenceNumber: 3,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '3',
        },
        {
          id: '1zhjGKFv',
          referenceId: '2.1.4',
          label: 'Threat from third party',
          sequenceNumber: 4,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '4',
        },
        {
          id: 'MXDbRpMi',
          referenceId: '2.1.5',
          label: 'Problem-solving/self-management skill deficits.',
          sequenceNumber: 5,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '5',
        },
        {
          id: 'dxmbzVbm',
          referenceId: '2.1.6',
          label: 'Anger management deficits.',
          sequenceNumber: 6,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '6',
        },
        {
          id: 'MwtEa8GZ',
          referenceId: '2.1.7',
          label: 'Intimidating/controlling.',
          sequenceNumber: 7,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '7',
        },
        {
          id: 'hh3mTay0',
          referenceId: '2.1.8',
          label: 'Inappropriate sexual activity.',
          sequenceNumber: 8,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '8',
        },
        {
          id: 'ot4oDVkB',
          referenceId: '2.1.9',
          label: 'Poor social skills.',
          sequenceNumber: 9,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '9',
        },
        {
          id: 'RggTy6kx',
          referenceId: '2.1.10',
          label: 'Peers outside of age range.',
          sequenceNumber: 10,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '10',
        },
        {
          id: 'ECMOzW2A',
          referenceId: '2.1.11',
          label: 'Racist/sexist behavior.',
          sequenceNumber: 11,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '11',
        },
        {
          id: 'KZmCr5Up',
          referenceId: '2.1.12',
          label: 'Underachievement.',
          sequenceNumber: 12,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '12',
        },
        {
          id: 'x16x3OgS',
          referenceId: '2.1.13',
          label: 'Outstanding charges.',
          sequenceNumber: 13,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '13',
        },
        {
          id: 'rOhf0Qg1',
          referenceId: '2.1.14',
          label: 'Other.',
          sequenceNumber: 14,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '14',
        },
        {
          id: 'RcNG7S6s',
          referenceId: '2.1.14',
          label: 'Other. Specify',
          sequenceNumber: 15,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'parts2to7',
          hideSequenceNumber: true,
        },
      ],
    },
    {
      type: 'field-group',
      heading: '2.2a - History of Perpetration: Sexual Assault',
      fields: [
        {
          id: 'LCYMaOfB',
          referenceId: '2.2.1',
          label:
            'Sexual assault, extrafamilial, child/adolescent - male victim.',
          sequenceNumber: 16,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '15',
        },
        {
          id: 'SifQSz8l',
          referenceId: '2.2.2',
          label:
            'Sexual assault, extrafamilial, child/adolescent - female victim.',
          sequenceNumber: 17,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '16',
        },
        {
          id: 'ELZJyIdO',
          referenceId: '2.2.3',
          label: 'Sexual assault, extrafamilial, adult - male victim.',
          sequenceNumber: 18,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '17',
        },
        {
          id: 'r5ZMqIm0',
          referenceId: '2.2.4',
          label: 'Sexual assault, extrafamilial, adult - female victim.',
          sequenceNumber: 19,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '18',
        },
        {
          id: 'SuK2pIar',
          referenceId: '2.2.5',
          label:
            'Sexual assault, intrafamilial, child/adolescent - male victim.',
          sequenceNumber: 20,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '19',
        },
        {
          id: 'ukVvia16',
          referenceId: '2.2.6',
          label:
            'Sexual assault, intrafamilial, child/adolescent - female victim.',
          sequenceNumber: 21,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '20',
        },
        {
          id: 'gUtmtYFp',
          referenceId: '2.2.7',
          label:
            'Sexual assault, intrafamilial, adult - spouse/partner victim.',
          sequenceNumber: 22,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '21',
        },
      ],
    },
    {
      type: 'field-group',
      heading:
        '2.2b - History of Perpetration: Nonsexual Physical Assault and Other Forms of Violence',
      fields: [
        {
          id: 'p61bAQZF',
          referenceId: '2.2.8',
          label: 'Physical assault, extrafamilial - adult victim.',
          sequenceNumber: 23,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '22',
        },
        {
          id: 'qNyh6I27',
          referenceId: '2.2.9',
          label: 'Physical assault, intrafamilial - child/adolescent victim.',
          sequenceNumber: 24,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '23',
        },
        {
          id: 'q97RSQsP',
          referenceId: '2.2.10',
          label: 'Physical assault, intrafamilial - adult victim.',
          sequenceNumber: 25,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '24',
        },
        {
          id: 'htbCdTPj',
          referenceId: '2.2.11',
          label: 'Assault on an authority figure.',
          sequenceNumber: 26,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '25',
        },
        {
          id: '0TWJnacT',
          referenceId: '2.2.12',
          label: 'Stalking/harassment.',
          sequenceNumber: 27,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['c4458a9a-a276-4a35-a850-ef6d8e3390f5>MwtEa8GZ>1'],
                  message: '',
                  conditions: [],
                },
              ],
            },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '26',
        },
        {
          id: 'eUIqWhA4',
          referenceId: '2.2.13',
          label: 'Weapon use.',
          sequenceNumber: 28,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '27',
        },
        {
          id: 'duNCNpMU',
          referenceId: '2.2.14',
          label: 'Fire setting.',
          sequenceNumber: 29,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '28',
        },
      ],
    },
    {
      type: 'field-group',
      heading:
        '2.2c - History of Perpetration: Other Forms of Antisocial Behavior',
      fields: [
        {
          id: 'jhSXgHCh',
          referenceId: '2.2.15',
          label: 'Impaired driving.',
          sequenceNumber: 30,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '29',
        },
        {
          id: 'AoEGKC32',
          referenceId: '2.2.16',
          label: 'Shoplifting.',
          sequenceNumber: 31,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '30',
        },
        {
          id: 'r7LPjyhN',
          referenceId: '2.2.17',
          label: 'White collar crime.',
          sequenceNumber: 32,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '31',
        },
        {
          id: 'leWXqtd4',
          referenceId: '2.2.18',
          label: 'Gang participation.',
          sequenceNumber: 33,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>dsZjqchv>1'],
                  message:
                    'If item {18} in section {2.2} is answered "{Yes}", then item {24} in section {1.5} must also be answered "{Yes}." We have already made this adjustment for you. Please see LS/CMI scoring guide for more details.',
                  conditions: [],
                },
              ],
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '||',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>at6yivCL>3',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>at6yivCL>2',
                          comparator: '1',
                        },
                      ],
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If item {18} in section {2.2} is answered "{Yes}," then consider answering item {25} in section {1.5} as "{0}" or "{1}".',
                },
              ],
            },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '32',
        },
        {
          id: 'JKhpRAbJ',
          referenceId: '2.2.19',
          label: 'Organized crime.',
          sequenceNumber: 34,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>dsZjqchv>1'],
                  message:
                    'If item {19} in section {2.2} is answered "{Yes}", then item {24} in section {1.5} must also be answered "{Yes}." We have already made this adjustment for you. Please see LS/CMI scoring guide for more details.',
                  conditions: [],
                },
              ],
              warningCheck: [
                {
                  conditions: [
                    {
                      operator: '||',
                      conditions: [
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>at6yivCL>3',
                          comparator: '1',
                        },
                        {
                          operator: '=',
                          variable:
                            '9c69da84-9168-452e-8d06-ff76966ddec5>at6yivCL>2',
                          comparator: '1',
                        },
                      ],
                    },
                  ],
                  conditionModifier: null,
                  warning:
                    'If item {19} in section {2.2} is answered "{Yes}," then consider answering item {25} in section {1.5} as "{0}" or "{1}".',
                },
              ],
            },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '33',
        },
        {
          id: 'ua0wj1MJ',
          referenceId: '2.2.20',
          label: 'Hate crime.',
          sequenceNumber: 35,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['c4458a9a-a276-4a35-a850-ef6d8e3390f5>ECMOzW2A>1'],
                  message:
                    'If item {20} in section {2.2} is answered "{Yes}", then item {11} in section {2.1} must also be answered "{Yes}." We have already made this adjustment for you. Please see LS/CMI scoring guide for more details.',
                  conditions: [],
                },
              ],
            },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '34',
        },
        {
          id: 'LfSmVFZS',
          referenceId: '2.2.21',
          label: 'Terrorist activity.',
          sequenceNumber: 36,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '35',
        },
      ],
    },
    {
      type: 'field-group',
      heading: '3.1a - History of Incarceration: Past',
      fields: [
        {
          id: 'pAWdLdHa',
          referenceId: '3.1.1',
          label: 'Last classification maximum.',
          sequenceNumber: 37,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '36',
        },
        {
          id: '9BJUemmg',
          referenceId: '3.1.2',
          label: 'Last classification medium.',
          sequenceNumber: 38,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '37',
        },
        {
          id: 'nGNxEPVC',
          referenceId: '3.1.3',
          label: 'Last classification minimum.',
          sequenceNumber: 39,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '38',
        },
        {
          id: 'ANipLJij',
          referenceId: '3.1.4',
          label: 'Past federal incarceration.',
          sequenceNumber: 40,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '39',
        },
        {
          id: 'pfbI1qNN',
          referenceId: '3.1.5',
          label: 'Past state/provincial incarceration.',
          sequenceNumber: 41,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '40',
        },
        {
          id: 'ouscqD9L',
          referenceId: '3.1.6',
          label: 'Past classification unknown.',
          sequenceNumber: 42,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '41',
        },
      ],
    },
    {
      type: 'field-group',
      heading: '3.1b - History of Incarceration: Present',
      fields: [
        {
          id: 'LsKhNkVF',
          referenceId: '3.1.7',
          label: 'Protective custody.',
          sequenceNumber: 43,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '42',
        },
        {
          id: 'prmmzDyJ',
          referenceId: '3.1.8',
          label: 'Treatment recommended/ordered.',
          sequenceNumber: 44,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '43',
        },
        {
          id: 'YZX4ZHZo',
          referenceId: '3.1.8a',
          label: 'Treatment recommended/ordered. Specify',
          sequenceNumber: 45,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'parts2to7',
          hideSequenceNumber: true,
        },
        {
          id: 'BA1zk5Wv',
          referenceId: '3.1.9',
          label: 'Misconduct/behavior report during current incarceration.',
          sequenceNumber: 46,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['9c69da84-9168-452e-8d06-ff76966ddec5>ZNg14HXv>1'],
                  message:
                    'If item {9} in section {3.1} is answered "{Yes}", then item {7} in section {1.1} must also be answered "{Yes}." We have already made this adjustment for you. Please see LS/CMI scoring guide for more details.',
                  conditions: [],
                },
              ],
            },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '44',
        },
        {
          id: '4tIXBCOf',
          referenceId: '3.1.9a',
          label:
            'Misconduct/behavior report during current incarceration. Number',
          sequenceNumber: 47,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'parts2to7',
          hideSequenceNumber: true,
        },
        {
          id: 'nSh4i7R5',
          referenceId: '3.1.10',
          label: 'Administrative segregation.',
          sequenceNumber: 48,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '45',
        },
        {
          id: 'tL4Ca0D7',
          referenceId: '3.1.11',
          label: 'Security management concerns.',
          sequenceNumber: 49,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '46',
        },
        {
          id: 'kWPO8upf',
          referenceId: '3.1.11a',
          label: 'Security management concerns. Specify',
          sequenceNumber: 50,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'parts2to7',
          hideSequenceNumber: true,
        },
      ],
    },
    {
      type: 'field-group',
      heading: '3.2 - Barriers to Release',
      fields: [
        {
          id: '83XeBFaL',
          referenceId: '3.2.1',
          label:
            'Community supervision inappropriate due to specific risk/need factors identified in Section 2.',
          sequenceNumber: 51,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '47',
        },
        {
          id: 'EuucvoU5',
          referenceId: '3.2.1a',
          label:
            'Community supervision inappropriate due to specific risk/need factors identified in Section 2. Specify reason',
          sequenceNumber: 51,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'parts2to7',
          hideSequenceNumber: true,
        },
        {
          id: 'bvSmIQAE',
          referenceId: '3.2.2',
          label:
            'Insufficient community supports for release (lack of accommodation, treatment services, family support, criminogenic community, etc.)',
          sequenceNumber: 53,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '48',
        },
        {
          id: 'JnVNb5KO',
          referenceId: '3.2.2a',
          label:
            'Insufficient community supports for release (lack of accommodation, treatment services, family support, criminogenic community, etc.) Specify reason',
          sequenceNumber: 54,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'parts2to7',
          hideSequenceNumber: true,
        },
        {
          id: 'AjD7bpVs',
          referenceId: '3.2.3',
          label: 'Notoriety of offence.',
          sequenceNumber: 55,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '49',
        },
        {
          id: '1sqBf276',
          referenceId: '3.2.3a',
          label: 'Notoriety of offence. Specify reason',
          sequenceNumber: 56,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'parts2to7',
          hideSequenceNumber: true,
        },
      ],
    },
    {
      type: 'field-group',
      heading: '4 - Other Client Issues',
      fields: [
        {
          id: 'Glgl2KBa',
          referenceId: '4.1',
          label: 'Financial problems.',
          sequenceNumber: 57,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '50',
        },
        {
          id: 'l2mY65j7',
          referenceId: '4.2',
          label: 'Homeless or transient.',
          sequenceNumber: 58,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '51',
        },
        {
          id: 'CJAt4HzE',
          referenceId: '4.3',
          label: 'Accommodation problems.',
          sequenceNumber: 59,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '52',
        },
        {
          id: 'OduEM7rN',
          referenceId: '4.4',
          label: 'Immigration issues.',
          sequenceNumber: 60,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '53',
        },
        {
          id: '77IfpZNL',
          referenceId: '4.5',
          label: 'Parenting concerns.',
          sequenceNumber: 61,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '54',
        },
        {
          id: 'mvBIJhoF',
          referenceId: '4.6',
          label: 'Health problems (HIV, AIDS, etc.).',
          sequenceNumber: 62,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '55',
        },
        {
          id: 'lYjH5Eep',
          referenceId: '4.7',
          label: 'Physical disability.',
          sequenceNumber: 63,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '56',
        },
        {
          id: 'onH7uuQ3',
          referenceId: '4.8',
          label: 'Learning disability.',
          sequenceNumber: 64,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '57',
        },
        {
          id: '0AACqavH',
          referenceId: '4.9',
          label: 'Fetal Alcohol Spectrum Disorder (FASD).',
          sequenceNumber: 65,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '58',
        },
        {
          id: '2KE2bXsX',
          referenceId: '4.10',
          label: 'Depressed.',
          sequenceNumber: 66,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '59',
        },
        {
          id: 'h4LCd1mp',
          referenceId: '4.11',
          label: 'Suicide attempts/threat.',
          sequenceNumber: 67,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '60',
        },
        {
          id: 'AEJ5V6Sx',
          referenceId: '4.12',
          label: 'Low self-esteem.',
          sequenceNumber: 68,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '61',
        },
        {
          id: '10VAfZFH',
          referenceId: '4.13',
          label: 'Shy/withdrawn.',
          sequenceNumber: 69,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '62',
        },
        {
          id: 'uSDCeFCk',
          referenceId: '4.14',
          label: 'Diagnosis of serious mental disorder.',
          sequenceNumber: 70,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '63',
        },
        {
          id: 'YMVxoj5V',
          referenceId: '4.15',
          label: 'Other evidence of emotional distress.',
          sequenceNumber: 71,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '64',
        },
        {
          id: 'dZrk1qP8',
          referenceId: '4.15a',
          label: 'Other evidence of emotional distress. Specify',
          sequenceNumber: 72,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'parts2to7',
          hideSequenceNumber: true,
        },
        {
          id: 'PMRyd3lW',
          referenceId: '4.16',
          label: 'Victim of family violence.',
          sequenceNumber: 73,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '65',
        },
        {
          id: 'ax4MGavz',
          referenceId: '4.17',
          label: 'Victim of physical assault.',
          sequenceNumber: 74,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '66',
        },
        {
          id: 'BVe57772',
          referenceId: '4.18',
          label: 'Victim of sexual assault.',
          sequenceNumber: 75,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '67',
        },
        {
          id: 'M39Lj31U',
          referenceId: '4.19',
          label: 'Victim of emotional abuse.',
          sequenceNumber: 76,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '68',
        },
        {
          id: 'UZgbdvgv',
          referenceId: '4.20',
          label: 'Victim of neglect.',
          sequenceNumber: 77,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            {
              label: 'Yes',
              value: '1',
              autoAnswer: [
                {
                  answer: ['c4458a9a-a276-4a35-a850-ef6d8e3390f5>PMRyd3lW>1'],
                  message:
                    'If item {20} in section {4} is answered "{Yes}", then item {16} in section {4} must also be answered "{Yes}." We have already made this adjustment for you. Please see LS/CMI scoring guide for more details.',
                  conditions: [],
                },
              ],
            },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '69',
        },
        {
          id: 'asZva23V',
          referenceId: '4.20a',
          label: 'Other. Specify',
          sequenceNumber: 78,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'parts2to7',
          hideSequenceNumber: true,
        },
      ],
    },
    {
      type: 'field-group',
      heading: '5 - Special Responsivity Considerations',
      fields: [
        {
          id: 'a6yhki7d',
          referenceId: '5.1',
          label: 'Motivation as a barrier.',
          sequenceNumber: 79,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '70',
        },
        {
          id: 'bSSlT4Ry',
          referenceId: '5.2',
          label: 'Engages in denial/minimization.',
          sequenceNumber: 80,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '71',
        },
        {
          id: 'JJ25jbuC',
          referenceId: '5.3',
          label: 'Interpersonally anxious.',
          sequenceNumber: 81,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '72',
        },
        {
          id: 'uTt9KQba',
          referenceId: '5.4',
          label: 'Woman, gender-specific issues.',
          sequenceNumber: 82,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '73',
        },
        {
          id: 'StAEcZaJ',
          referenceId: '5.5',
          label: 'Cultural issues.',
          sequenceNumber: 83,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '74',
        },
        {
          id: 'VD6d4WYG',
          referenceId: '5.6',
          label: 'Ethnicity issues.',
          sequenceNumber: 84,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '75',
        },
        {
          id: 'us46Qjgk',
          referenceId: '5.7',
          label: 'Low intelligence.',
          sequenceNumber: 85,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '76',
        },
        {
          id: '758gZ9lZ',
          referenceId: '5.8',
          label: 'Communication barriers.',
          sequenceNumber: 86,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '77',
        },
        {
          id: 'QNMpUK0x',
          referenceId: '5.9',
          label: 'Mental disorder.',
          sequenceNumber: 87,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '78',
        },
        {
          id: '1ncZjTBi',
          referenceId: '5.10',
          label: 'Antisocial personality/psychopathy.',
          sequenceNumber: 88,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'dropdown',
          payloadType: 'parts2to7',
          answers: [
            { label: 'Yes', value: '1' },
            { label: 'No', value: '0' },
            { label: 'Omit', value: '-1' },
          ],
          displayNumberOverride: '79',
        },
        {
          id: 'lPEc46cu',
          referenceId: '5.11',
          label: 'Other. Specify',
          sequenceNumber: 89,
          required: false,
          model: { type: '', payloadLocation: '' },
          type: 'text',
          payloadType: 'parts2to7',
          displayNumberOverride: '80',
        },
      ],
    },
  ],
};

/** ... */
const references: DataGatherer.Tool.Reference[] = [
  {
    id: '1.1.1',
    title: 'Reference Text',
    content:
      'The LS/CMI system may be used with youth aged 16 and over. However, for younger offenders, the Youth Level of Service/Case Management Inventory (YLS/CMI 2.0™) is required. The YLS/CMI 2.0 system may also be used with youthful offenders over the age of 16. For adults, record official convictions. Record the number of priors in the bracket. For items 1, 2, and 3, use of alternative measures is excluded. Alternative measures (e.g., diversion procedures) are interventions conducted by someone other than a judge.',
  },
  {
    id: '1.1.2',
    title: 'Reference Text',
    content:
      'The number of prior dispositions/convictions is at separate times. This means that any number of counts dealt with at the same time or with one sentence equals one disposition/conviction. If this item is marked Yes, then item 1 must also be Yes.',
  },
  {
    id: '1.1.3',
    title: 'Reference Text',
    content:
      'The number of prior dispositions/convictions is at separate times. If this item is marked Yes, then items 1 and 2 must also be marked Yes.',
  },
  {
    id: '1.1.4',
    title: 'Reference Text',
    content:
      'Mark Yes if there are three or more charges for which the client has received a disposition/conviction and is presently serving a sentence in an institution or in the community. Outstanding charges are not noted here but are noted in Section 2: Specific Risk/Need Factors.',
  },
  {
    id: '1.1.5',
    title: 'Reference Text',
    content:
      'Mark Yes if the offender was ever arrested or charged under the age of 16 years.',
  },
  {
    id: '1.1.6',
    title: 'Reference Text',
    content:
      'This includes incarcerations (jail or prison) as an adult and as a young offender/juvenile delinquent. This item includes any custodial sentence upon conviction (e.g., shock incarceration, revocation of probation). Do not include house arrest or pretrial detention. For forensic patients, not guilty by reason of insanity acquittals (NGRI) that result in placement in a hospital are included, but placements for observation and assessment are not. Do not score incompetent (unfit) to stand trial as a conviction.',
  },
  {
    id: '1.1.7',
    title: 'Reference Text',
    content:
      'Mark Yes if the offender was ever punished for institutional misconduct or received a behavior report. A finding of guilt and a sanction of at least “warned and counseled” is required for this item. Do not include conduct for which no punishment was adjudicated.\n\nRecord the number of misconducts or behavior reports in the space provided.',
  },
  {
    id: '1.1.8',
    title: 'Reference Text',
    content:
      'Mark Yes if the offender has been charged, breached probation, or had parole suspended during any prior community supervision. Community supervision includes probation, bail, community service order, parole, and mandatory supervision.',
  },
  {
    id: '1.1.1.1',
    title: 'Reference Text',
    content:
      'Strength for Criminal History:\n\nAn example of strength in this area could be a 50-year-old first offender who has been working steadily, is married, and is substance abuse free. The density of offending over time is very low and may be seen as a positive circumstance. If the area is a strength for the offender, then the Strength box under Criminal History is checked.',
  },
  {
    id: '1.2.9',
    title: 'Reference Text',
    content:
      'When in the labor market (either in the community or long-term imprisonment with work opportunities):\n\nAs a general guide, full-time employment is considered working 75% or more of a normal work week. For incarcerated offenders, score according to the amount of hours available. If an inmate is working less than 75% of available hours, then mark Yes for this item. Certain “unemployed” offenders are marked as No on this item. People marked No include offenders who have never entered the labor market because they are still in school; people who are currently homemakers or pensioners; seasonal workers who are employed at least 6 months of the year and then receive social support (e.g., some fishermen, loggers). \n\nWith the exceptions noted above (student, homemaker, etc.), if this item is marked Yes, then items 15, 16, and 17 must each be rated 0.',
  },
  {
    id: '1.2.10',
    title: 'Reference Text',
    content:
      'When in the labor market (either in the community or long-term imprisonment with work opportunities):\n\nMark Yes if, in general, the offender has been employed less than 50% of the last 12 months, or 50% of the 12 months prior to incarceration for offenders serving a sentence of less than 2 years. Some exceptions to the “50% of the last 12 months” guideline may apply. For example, an offender may work at many different fast food restaurants over the course of a year with a few days of unemployment between jobs. In this case, the offender is scored as Yes. \n\nDistinguish frequently unemployed from seasonal workers. Seasonal workers who change employer from year to year would be scored as Yes; seasonal workers who return to the same employer would be scored as No. If an inmate is serving a sentence in excess of 2 years, then score the inmate with respect to his or her participation in paid prison industries or training programs.\n\nAll offenders who were in the labor market for at least 12 continuous months or who were seasonal workers are eligible for scoring of items 10 and 11.',
  },
  {
    id: '1.2.11',
    title: 'Reference Text',
    content:
      'When in the labor market (either in the community or long-term imprisonment with work opportunities):\n\nMark Yes if the offender has never been employed in the community for 12 continuous months. Once again, an offender with multiple jobs with only a few days of unemployment between jobs would be scored as Yes here. This item assesses stability in an employment context that permits the building of prosocial relationships and pride in conventional pursuits. Include seasonal workers who change employer from year to year. If an inmate is serving a sentence in excess of 2 years, then score the inmate with respect to his or her participation in paid prison industries or training programs.',
  },
  {
    id: '1.2.12',
    title: 'Reference Text',
    content:
      'In school or when in school: \n\nItems 12 and 13 refer to achievement in education through a regular academic or technical high school program. Note that upgrading, equivalency, and correspondence programs are now considered as regular high school programs if the upgrading is recognized in a formal manner by educational authorities, such as a Ministry of Education or a State Department of Education. If, however, the offender is presently attending an alternative program of education, do assess his or her reward ratings for school in items 15, 16, and 17.\n\nMark Yes if the offender has not achieved a grade 10 education during attendance at an academic or technical high school or an officially recognized equivalent. Recall, however, the age considerations noted above.\n\nIf this item is marked Yes and the offender is over 19 years old, then item 13 must also be Yes.\n\nNote. If the offender is under age 17, do not mark item 12 as Yes, and if under age 19, do not mark item 13 as Yes. Instead, these items are omitted.',
  },
  {
    id: '1.2.13',
    title: 'Reference Text',
    content:
      'In school or when in school:\n\nItems 12 and 13 refer to achievement in education through a regular academic or technical high school program. Note that upgrading, equivalency, and correspondence programs are now considered as regular high school programs if the upgrading is recognized in a formal manner by educational authorities, such as a Ministry of Education or a State Department of Education. If, however, the offender is presently attending an alternative program of education, do assess his or her reward ratings for school in items 15, 16, and 17.\n\nMark Yes if the offender has not achieved a grade 12 education during attendance at an academic or technical high school or an officially recognized equivalent. If item 12 is marked Yes and the offender is over 19 years old, then this item must also be marked Yes.\n\nNote. If the offender is under age 17, do not mark item 12 as Yes, and if under age 19, do not mark item 13 as Yes. Instead, these items are omitted.',
  },
  {
    id: '1.2.14',
    title: 'Reference Text',
    content:
      'In school or when in school:\n\nMark Yes if the offender has had to leave school for disciplinary reasons or truancy.',
  },
  {
    id: '1.2.15',
    title: 'Reference Text',
    content:
      'Reward Ratings for Education:\n\nHighest Level (3). The offender expresses a high interest in schoolwork and school-related activities. He or she does homework, reads asssigned material, completes assignments promptly and reliably, and earns average to above average grades (C or higher; GPA of 2.0 or higher). He or she regularly attends school.\n\nLowest Level (0). The offender shows an active dislike for schoolwork and activities. Homework is late or not completed. Truancy and skipping classes are common. He or she wants to quit school and performs below average (grade D or F; GPA below 1.5).\n\nReward Ratings for Employment:\n\nFor pensioners and homemakers, rate as to satisfaction with present status.\n\nHighest Level (3). The offender expresses a strong interest in his or her job and expresses pride in abilities/performance. He or she has received positive recognition from a supervisor for work performance. His or her attendance is reliable. He or she is willing to work overtime. The offender wants to stay in the same line of work.\n\nLowest Level (0). “I hate it.” He or she sees the job as boring/dangerous/unpleasant. The offender does not perform well, and the job is seen as a means of earning a living only and not even satisfactory on those terms. His or her attendance is unreliable. He or she often arrives late for work. The offender wants to change jobs, and may quit even if another job is not yet available.',
  },
  {
    id: '1.2.16',
    title: 'Reference Text',
    content:
      'Reward Ratings for Education:\n\nHighest Level (3). He or she gets along with fellow students. The offender talks with other students and has lunch wth them. He or she spends time with fellow students outside of school. His or her best friends are in school.\n\nLowest Level (0). There are significant and continuous problems or virtually no contact with fellow students. He or she is isolated, fights with others, and is argumentative. His or her best friends are not in school.\n\nReward Ratings for Employment:\n\nHighest Level (3). Gets along with fellow workers. They talk together, take breaks together, lunch together, and participate in leisure pursuits together. They help each other on the job. There is a cooperative, friendly atmosphere.\n\nLowest Level (0). The offender has continous problems, including fighting, arguing, or being isolated. He or she participates in antisocial activities with fellow workers.',
  },
  {
    id: '1.2.17',
    title: 'Reference Text',
    content:
      "Note that separate criteria are provided for individuals who attend school and for individuals who work. \n\nReward Ratings for Education:\n\nHighest Level (3). Talks to teachers in and out of class. He or she has sought (or would seek) opinions of teachers regarding a personal or interpersonal problem or accomplishment. The offender respects teachers and values their opinions.\n\nLowest Level (0). The offender avoids and hates teachers. He or she heckles in class. There have been arguments with teachers and detentions. He or she has been sent to the principal's office for displays of disrespect\n\nReward Ratings for Employment:\n\nHighest Level (3). The offender respects, if not likes, his or her supervisor. He or she talks with the supervisor, even regarding non-job matters, and would approach the boss with problems. He or she follows orders willingly.\n\nLowest Level (0). The offender and authority figure experience significant and continuing problems/conflicts. The offender does not follow orders, is argumentative, and feels that others are treated better by the boss.",
  },
  {
    id: '1.2.1.2',
    title: 'Reference Text',
    content:
      'Strength for Eductional:\n\nInvolvement in educational and employment activities can be a particularly important area of strength because of the large time commitment required and the varied sources of interpersonal rewards. As an illustration, a client may have enormous respect for an employer (or teacher) and likes work (school) so much that he/she spends not only time at work/school but also works overtime/does extra homework. This involvement and commitment to prosocial activities serves to distance the offender from situations that may be criminogenic.',
  },
  {
    id: '1.3.18',
    title: 'Reference Text',
    content:
      'Highest Level (3). The offender is in a highly rewarding/caring relationship (marital, common-law) or is satisfied with “single” status. Note that relationships may include same-sex partners. Do not assume that single, divorced, or widowed offenders are to be scored as 0 or 1 automatically. Investigate their satisfaction with their “single” status.\n\nLowest Level (0). The relationship is characterized as unpleasant/uncaring/hostile/indifferent, possibly with intimate violence. Alternatively, the offender is not presently in a relationship and is unsatisfied with “single” status (e.g., feels lonely, wants to find a partner).\n\nNote. Consider the following points in assessing the above reward rating for an offender’s situation:\n\n- frequent arguments\n- unwanted pregnancy\n- infidelity\n- conflict over child rearing\n- conflict over money\n- contemplating separation/divorce\n- accepting separation/divorce\n- stress for individual problems of partners\n- difficulty regarding openness/warmth/intimacy\n- sexual dissatisfaction\n- harassment from ex-partner\n- communication problems\n- conflict with in-laws/parents\n- conflict with companions/friends\n- conflict associated with ex-partners\n- conflict over leisure time\n- implementing separation/divorce\n- child access and custody issues\n- excessive dependence\n- physical, psychological, and/or sexual abuse',
  },
  {
    id: '1.3.19',
    title: 'Reference Text',
    content:
      'This item is not limited to the biological parent(s) and may include the adoptive parent(s) or others (e.g., grandparents) who raised the offender.\n\nHighest Level (3). A highly rewarding, satisfying relationship exists. The offender and his or her family see or write/email each other often. They hug or kiss when greeting. The relationship is liking/loving, and is open and warm. They talk about important matters. The offender cares about what his or her parents think, expect, and feel.\n\nLowest Level (0). The offender and his or her family have arguments when they are together. They see, call, write, or email each other rarely, and dislike/hate each other. The offender does not care what his or her parents think, feel, or expect. This score indicates a punishing, unpleasant, uncaring, hostile, indifferent relationship; OR both parents are deceased; OR one parent is deceased or absent from home and there is a negative relationship with the one seen most often; OR the offender was raised in foster home(s) with no attachment to guardians.',
  },
  {
    id: '1.3.20',
    title: 'Reference Text',
    content:
      'Highest Level (3). The offender has a highly rewarding relationship with others, such as siblings, grandparents, aunts, uncles, cousins, or in-laws, who are seen or contacted regularly.\n\nLowest Level (0). No positive relationships exist with others, such as siblings, grandparents, aunts, uncles, cousins, or in-laws, who are seen or contacted regularly.',
  },
  {
    id: '1.3.21',
    title: 'Reference Text',
    content:
      'Mark Yes if a parent, sibling, spouse, or close (with contact) relative has a criminal record.',
  },
  {
    id: '1.3.1.3',
    title: 'Reference Text',
    content:
      'Strength for Family:\nWarm, caring relationships that are prosocial in orientation can offset interactions with delinquent peers and provide support in case management plans targeting other criminogenic needs. There are a number of possibilities here. For example, a parent can care for young children while the offender seeks employment, or a partner may assist the client in keeping a behavioral log of temptations to drink as part of the offender’s homework assignment from an alcohol treatment program. Note that stable family and marital relationships can be an area in the client’s life that may be relatively stress-free and comforting and facilitate the transition and maintenance to a prosocial lifestyle.',
  },
  {
    id: '1.4.22',
    title: 'Reference Text',
    content:
      'When in the Community. Mark Yes if the offender has not participated or been involved in a formal organization during the last 12 months (e.g., union, service club, sports club or team, church). For the offender who is participating in an Anonymous group (e.g., Alcoholics Anonymous, Narcotics Anonymous), consider the motivation or incentives for attending and the degree of involvement. Is the offender participating in the group’s social activities (e.g., dances, weekend BBQs)? Is the offender receiving social rewards from participation? Regular church attendance without involvement in other church activities would not be considered participation in an organized activity.\n\nInmates. For inmates serving a sentence of less than 2 years, score this item based on participation in the year prior to incarceration. For longer sentenced inmates, assess participation in regularly scheduled programs within prison (e.g., lifer’s groups, church ministry).',
  },
  {
    id: '1.4.23',
    title: 'Reference Text',
    content:
      'Highest Level (3). Involved in highly rewarding/satisfying activities such as stamp collecting, weight lifting, martial arts, or car repairs.\n\nLowest Level (0). The offender has no leisure activities/is bored/has a lot of idle time. He or she is involved in explicit criminogenic activities.\n\nDiscover in what ways an offender’s activities are rewarding for him or her. How is his or her use of time possibly impacting on, or relating to, other need areas such as education/employment, or alcohol/drugs? For example, being bored and with idle time can lead to substance abuse; spare time may not be used to improve educational/employment skills that could then lead to a more stable employment and financial situation.',
  },
  {
    id: '1.4.1.4',
    title: 'Reference Text',
    content:
      'Strength for Leisure:\n\nFor example, a longstanding commitment to a sports team may counteract the temptation to use drugs in order to maintain health and participate in the sport. Participation on a committee for a religious organization could strengthen prosocial values and interactions with prosocial others. Most religious organizations further prosocial values of honesty, altruism, and charity that are incongruent with antisocial values and beliefs. Thus, involvement in such organizations strengthens prosocial values and promotes active resistance the influence of criminal attitudes, values, and beliefs.',
  },
  {
    id: '1.5.24',
    title: 'Reference Text',
    content:
      'Mark Yes if the offender associates with individuals who may not be close friends, but have criminal records or are involved in criminal activity. Note that all inmates will receive a score of Yes on this item. In addition, offenders with a drug conviction are also likely to know criminals, given that drugs are obtained from other criminals. Thus, this item will usually be marked Yes for offenders with a drug conviction, except in cases of prescription fraud.',
  },
  {
    id: '1.5.25',
    title: 'Reference Text',
    content:
      'Friends are associates with whom one spends leisure time, whose opinions are valued, who provide help when in difficulty, etc. Inmates serving sentences in excess of 2 years should be assessed on their relationship with other inmates (e.g., spends time with other inmates, respects them).\n\nHighest Level (3). The offender’s friends are not involved in crime or do not have criminal records. There are few procriminal associates of any significance in terms of frequency or contact.\n\nLowest Level (0). The offender has friends (or did prior to incarceration if serving a sentence less than 2 years) who have criminal records or are involved in criminal activity.',
  },
  {
    id: '1.5.26',
    title: 'Reference Text',
    content:
      'Mark Yes if the offender has fewer than three anticriminal acquaintances. Anticriminal acquaintances are those who do not have criminal records or are not involved in criminal activity.',
  },
  {
    id: '1.5.27',
    title: 'Reference Text',
    content:
      'Once again, friends are individuals who the offender respects and spends time with. Anticriminal friends are not involved in criminal activities and do not have criminal records.\n\nHighest Level (3). The offender has many anticriminal friends and associates. Friends are not involved in crime and do not have criminal records. There are few procriminal associates of any significance in terms of frequency or contact.\n\nLowest Level (0). The offender has less than three friends who are not supportive of criminal acts. Friends are involved in crime or have criminal records.',
  },
  {
    id: '1.5.1.5',
    title: 'Reference Text',
    content:
      'Strength for Companions:\n\nThis subcomponent should only be considered a strength if item 26 is marked No and item 27 is rated as 3 or 2. In addition, anticriminal friends are very influential and present positive role models for the offender.',
  },
  {
    id: '1.6.28',
    title: 'Reference Text',
    content:
      'If item 30 is rated 0 or 1, then this item must be marked Yes. Some offenders will report heavy alcohol consumption but also claim it is no problem. Assessment of an alcohol “problem” depends upon the interviewer’s assessment and not the offender’s evaluation.',
  },
  {
    id: '1.6.29',
    title: 'Reference Text',
    content:
      'If item 31 is rated as 0 or 1, then this item must be marked Yes. The same assessment conditions apply as for item 28.',
  },
  {
    id: '1.6.30',
    title: 'Reference Text',
    content:
      'This item refers to the offender’s alcohol abuse, or if the offender perceives him- or herself as having a problem with alcohol. “Currently” refers to the past calendar year regardless of the location of the offender. Some examples that would warrant a 0 or 1 rating are (a) drinking to intoxication and (b) majority of social activities are centered around alcohol use. When assessing an incarcerated client who was admitted to prison within the last year consider his/her drinking behavior prior to incarceration as well as any drinking behavior while incarcerated. Use items 32 to 35 to assist in scoring this item.\n\nNote that a situation could arise whereby a client entered prison with severe substance abuse problems, scoring on all items, but who has not abused substances during the past year in prison. This client may then be released one year later and his/her score could decrease significantly. This situation may give rise to using the override feature of the LS/CMI but it should be justified.\n\nHighest Level (3). There is no evidence of current problems. The offender is an abstainer or controlled recreational user where the use does not interfere with normal behavior and relationships (e.g., maintains employment, absence of parental/marital conflict over use).\n\nLowest Level (0). Alcohol abuse seriously interferes with maintaining a prosocial lifestyle. At least one of items 32 through 35 is marked Yes on the basis of current use. It is advisable to first review items 32 to 35 for offenders who are denying or minimizing abuse.',
  },
  {
    id: '1.6.31',
    title: 'Reference Text',
    content:
      'This item refers to the offender’s drug abuse, or if the offender perceives him- or herself as having a problem with drugs. “Currently” refers to the past calendar year regardless of the location of the offender (whether incarcerated or not). Use items 32 to 35 to assist in scoring this item.\n\nNote that a situation could arise whereby a client entered prison with severe substance abuse problems, scoring on all items, but who has not abused substances during the past year in prison. This client may then be released one year later and his/her score could decrease significantly. This situation may give rise to using the override feature of the LS/CMI but it should be justified.\n\nHighest Level (3). There is no evidence of current problems. The offender is an abstainer or controlled recreational user where the use does not interfere with normal behavior and relationships (e.g., maintains employment, absence of parental/marital conflict over use).\n\nLowest Level (0). Substance abuse seriously interferes with maintaining a prosocial lifestyle. At least one of items 32 through 35 is marked Yes on the basis of current use. It is advisable to first review items 32 to 35 for offenders who are denying or minimizing abuse.\n\nSpecify the type of drug(s) used in the space provided.\n\nItems 32 to 35 are evaluated based on current use. If the offender has stopped abusing alcohol/drugs for more than a year, these items are marked No.',
  },
  {
    id: '1.6.32',
    title: 'Reference Text',
    content:
      'Mark Yes if the use (not only the possession, trafficking, importation) of alcohol or drugs contributed, is contributing, or could contribute to violation of law, based on offender’s official record or your knowledge of offender’s situation. Some examples are trafficking in drugs to support a habit; break, enter, and thefts of property to obtain money for drugs; parole violations; driving while impaired; or obtaining prescription drugs by fraud.',
  },
  {
    id: '1.6.33',
    title: 'Reference Text',
    content:
      'Mark Yes if the use of alcohol or drugs contributed to problems with marital or family situation, or if significant others have had complaints about the offender’s drinking or drug use.',
  },
  {
    id: '1.6.34',
    title: 'Reference Text',
    content:
      'Mark Yes if the use of alcohol or drugs contributed to problems with school or employment. Examples include having a hangover that prevented the offender from going to school or work, being asked to leave school because of drug use, or losing employment because of intoxication.',
  },
  {
    id: '1.6.35',
    title: 'Reference Text',
    content:
      'Mark Yes if the use of drugs or alcohol has contributed to physical complaints or if a medical doctor has warned the offender about drug/alcohol use. There is frequent use and a high quantity of consumption, drinking to unconsciousness, or difficulty reducing intake. Financial difficulties due to use have resulted. Use of a substance to avoid a hangover or withdrawal, delirium tremens (i.e., confusion and visual hallucinations), use of the substance first thing in the morning, sneaking drinks or “fixes,” and blackouts are other indicators.',
  },
  {
    id: '1.6.1.6',
    title: 'Reference Text',
    content:
      'Strength for Alcohol/Drug Problem:\n\nAn example of a strength is a recovering alcoholic who has not drank for a number of years and is actively involved in attending support groups and warns about the negative effects of substance abuse. Such firmly held anti-drinking beliefs might distance the offender from others who abuse alcohol and sensitize him or her to situations that may occasion relapse. Further examples may include a teetotaller (i.e., a total abstainer) or someone active in an anti-alcohol or anti-drug campaign (e.g., Mothers Against Drunk Driving; MADD).',
  },
  {
    id: '1.7.36',
    title: 'Reference Text',
    content:
      'Highest Level (3). The offender places emphasis on the negative consequences of law violation for the offender, the victim, and the community. He or she accepts responsibility for actions and the consequences of law violation. The offender rejects or places more realistic limits on rationalizations or justifications for law violations. He or she is sensitive to other people’s needs and feelings, and identifies with the victim(s) of a crime. Expressions are made about the risks involved in associating with criminal others or accepting their values.\n\nThe offender has an easy-going, calm temperament. Angry and hostile feelings are absent.\n\nLowest Level (0). The offender places emphasis on the usefulness of criminal activity. Motives are more readily served by crime than by noncrime. He or she accepts the common rationalizations or justifications for law violations (e.g., “it wasn’t my fault,” “no one was hurt,” “the victim had it coming to him,” “the cops were always on me for something”). He or she denies or minimizes responsibility for actions and the consequences of law violation. There is outright rejection that harm was caused to the victim or failure to empathize or be sensitive to the feelings, wishes, and expectations of others including the victim(s) of criminal behavior. He or she accepts criminal others and their values and activities, and expresses hostility toward the criminal justice system.\n\nThe offender is angry, hostile, resentful, and defiant. He or she is prone to “What the hell?” or “I give up/don’t give a damn."',
  },
  {
    id: '1.7.37',
    title: 'Reference Text',
    content:
      'Here, “convention” means an alternative to crime and criminal lifestyle.\n\nHighest Level (3). The offender supports society’s institutions (government, business, labor, service systems, home and family, school and work, spiritual institutions, recreational and social organizations) and their underlying values (order, peace, justice, material satisfaction, love and affection, security, interpersonal satisfaction, monetary and other measures of achievement). He or she expresses positive attitudes and feelings toward conventional/noncriminal others (peers, parents, siblings, spouse, teachers, employers). The offender values interactions with noncriminal others and indicates positive functions of conventional activities (e.g., working, studying, playing sports, controlled drinking) and emphasis on the rewards of such activities. He or she has a sense of accomplishment and feelings of self-worth based on achievement in conventional pursuits and activities.\n\nLowest Level (0). There is a general disregard for convention/noncrime alternatives. The offender is nonsupportive of convention, is hostile, and rejects the values underlying convention. He or she shows weak ties to conventional settings such as home and family, and school/work. The offender is negative, hostile, and rejecting of noncriminal others (e.g., “I don’t care what they think”). He or she invalidates or rejects noncriminal activities and their rewards, has a tolerance for deviance in general, and is negative or hostile toward authority.',
  },
  {
    id: '1.7.38',
    title: 'Reference Text',
    content:
      'Mark Yes if the offender denies the fairness/appropriateness of his or her sentence; denies/minimizes injury; denies/minimizes responsibility for current offence; or views himself or herself in regard to the offence/sentence as the victim of circumstances, misunderstandings, unworthy others, or an unfair system.',
  },
  {
    id: '1.7.39',
    title: 'Reference Text',
    content:
      'Mark Yes if the offender objects to his or her classification or placement, and/or there is an unwillingness to comply or cooperate or to seek assistance for significant problems. He or she is poorly motivated to address criminogenic factors.',
  },
  {
    id: '1.7.1.7',
    title: 'Reference Text',
    content:
      'Strength for Procriminal Attitude:\n\nProsocial values and acceptance of responsibility and compliance with supervision can be a particularly strong countervailing influence to other criminogenic factors. To be viewed as a Strength, none of the items in this subcomponent should be rated 0 or 1 or marked Yes. An example would be an inmate with a well-established prosocial attitude/orientation. Even surrounded by negative models (i.e., other inmates) and opportunities to express antisocial views without reprisal from the other inmates, his or her prosocial attitude/orientation could be sufficiently strong enough to resist influence from antisocial others.',
  },
  {
    id: '1.8.40',
    title: 'Reference Text',
    content:
      'The primary purpose of this item is to identify very high risk/need cases characterized by extreme egocentrism and a pattern of violations of trust and responsibility.\n\nMark Yes if the applicability of a diagnosis of Antisocial Personality Disorder, psychopathy, or some other psychiatric or forensic diagnosis with significant and clear links to risk of criminal activity is suspected. Examples include a “pedophile” with deviant sexual arousal pattern, or delusional thinking with potential for violence (“People are out to get me”).\n\nEmotional problems and even psychosis without clear criminogenic potential are not sufficient to score Yes here (although such problems would be noted in other LS/CMI sections).\n\nIf the offender has been assessed within the past year and the interviewer has knowledge of antisocial behavioral problems that the assessment described, then mark Yes for this item.\n\nIf the offender has never been assessed, or if it is unknown whether the offender has been assessed, but there are indicators of problems, mark Yes for this item. Sample problems include:\n\n- hostility; anger, potential for assaultive behavior; over-assertion/aggression\n\n- disregard for feelings of others, possibility of reduced ability or inability to experience guilt/shame; he or she may be superficially “charming” but appears to repeatedly disregard rules and feelings of others; impulsivity',
  },
  {
    id: '1.8.41',
    title: 'Reference Text',
    content:
      'This item is automatically completed based on responses to other items.\n\nIt is marked Yes only if 41a and at least one of 41b, 41c, or 41d is marked Yes.\n\na. Severe problems of adjustment in childhood, as indicated by school and social welfare records, or arrested or charged under age 16. (item 5)\n\nIf records indicate (i) severe adjustment problems during childhood or (ii) the offender was marked as Yes for item 5, then mark Yes for a.\n\nb. Official record of assault/violence. \n\nIf the offender has an official record of assault/violence, mark Yes for b.\n\nPrior or current assaultive/violent offences include violent misconducts. This item refers to both adult and young offender/juvenile delinquent history. An assaultive/violent offence is one in which there was harm, potential harm, or threat of harm, an element of coercion or force, be it physical or psychological; or the presence of a weapon. In a case where there is an official record but not a conviction for an assaultive/violent offence, consider whether the act could be seen as serious assaultive or violent behavior (e.g., stalking, charges withdrawn after attending counselling).\n\nc. Escape history from a correctional facility, unlawfully-at-large.\n\nIf the offender has an official record of escape history, mark Yes for c.\n\nThis includes a history of escape or attempted escape from a youth or adult correctional facility, including institutional and residential settings. Also includes unlawfully-at-large, escape, or attempted escape from police or prison escort.\n\nd. Charge laid, probation breached, or parole suspended during prior community supervision. (item 8)\n\nIf the offender was marked as Yes for item 8, then d is marked Yes.',
  },
  {
    id: '1.8.41a',
    title: 'Reference Text',
    content:
      'If item 5 was scored Yes, then this item has been scored Yes. If item 5 was scored No or was omitted, then only mark this item as Yes if records indicate severe adjustment problems during childhood.',
  },
  {
    id: '1.8.41b',
    title: 'Reference Text',
    content:
      'Mark Yes if there is prior or current assaultive/violent offences, including violent misconducts. Refers to both adult and young offender/juvenile delinquent history. An assaultive/violent offence is one in which there was harm, potential harm, or threat of harm; an element of coercion or force, be it physical or psychological; or the presence of a weapon. In a case where there is an official record but not a conviction for an assaultive/violent offence, consider whether the act could be seen as serious assaultive or violent behavior (e.g., stalking, charges withdrawn after attending counselling).',
  },
  {
    id: '1.8.41c',
    title: 'Reference Text',
    content:
      'Mark Yes if the offender has a history of escape or attempted escape from a youth or adult correctional facility, including institutional and residential settings. Also includes Unlawfully-at-Large, escape or attempted escape from police or prison escort.',
  },
  {
    id: '1.8.41d',
    title: 'Reference Text',
    content: 'This item has been scored based on the response to item 8.',
  },
  {
    id: '1.8.42',
    title: 'Reference Text',
    content:
      'This item is automatically completed based on responses to other items. It is marked Yes if the offender is marked Yes on at least one of the following:\n\na. Supportive of crime. (item 36)\n\nb. Unfavorable toward convention. (item 37)\n\nc. Poor, toward supervision/treatment. (item 39)',
  },
  {
    id: '1.8.42a',
    title: 'Reference Text',
    content:
      'This item is automatically completed based on responses to other items. If item 36 was rated as 0 or 1, then this item is marked Yes.',
  },
  {
    id: '1.8.42b',
    title: 'Reference Text',
    content:
      'This item is automatically completed based on responses to other items. If item 37 was rated as 0 or 1, then this item is marked Yes.',
  },
  {
    id: '1.8.42c',
    title: 'Reference Text',
    content:
      'This item is automatically completed based on responses to other items. If item 39 was rated as 0 or 1, then this item is marked Yes.',
  },
  {
    id: '1.8.43',
    title: 'Reference Text',
    content:
      'This item is automatically completed based on responses to other items. It is marked Yes if the offender is marked Yes or 0-1 on at least four of the following:\n\n43a. Financial problems.\n\nRate the degree of financial problems according to the following rating scale:\n\n3. Longstanding pattern of effective management.\n\n2. No current difficulties.\n\n1. Situational or minor difficulties or need to explore situation further.\n\n0. Severe difficulties or no visible means of support.\n\nA “difficulty” is something that cannot easily be done; an obstacle or a hindrance; trouble. Therefore, debts (e.g., mortgage, student loan) are not necessarily difficulties if they are manageable. As a general consideration, is the offender’s financial situation a current stressor, regardless of the source of income (including criminal activities)?\n\nNote. Refer to the Interview Guide for examples of questions that can guide making the above rating. It is appropriate to involve the offender in this process.\n\n43b. 3 or more address changes last year. \n\nIf there are three or more address changes in the last year, mark Yes for 43b. Do not include a period of incarceration as an address change unless the offender did not return to the prior address upon release. Record the number of address changes within the last 12 months or in the year prior to incarceration in the space provided.\n\n43c. Never employed for a full year. (item 11)\n\nIf item 11 was marked as Yes, mark Yes for 43c.\n\n43d. Less than regular grade 10 or equivalent. (item 12) \n\nIf item 12 was marked as Yes, mark Yes for 43d. \n\n43e. Suspended or expelled at least once. (item 14)\n\nIf item 14 was marked as Yes, mark Yes for 43e. \n\n43f. Nonrewarding, parental. (item 19)\n\nIf item 19 was rated as 0 or 1, mark Yes for 43f. \n\n43g. Could make better use of time. (item 23)\n\nIf item 23 was rated as 0 or 1, mark Yes for 43g. \n\n43h. Few anticriminal friends. (item 27)\n\nIf item 27 was rated as 0 or 1, mark Yes for 43h.',
  },
  {
    id: '1.8.43a',
    title: 'Reference Text',
    content:
      'Rate the degree of financial problems.\n\nReward Rating for Financial Problems\n\n3. Longstanding pattern of effective management.\n2. No current difficulties.\n1. Situational or minor difficulties or need to explore situation further.\n0. Severe difficulties or no visible means of support.\n\nA “difficulty” is something that cannot easily be done; an obstacle or a hindrance; trouble. Therefore, debts (e.g., mortgage, student loan) are not necessarily difficulties if they are manageable. As a general consideration, is the offender’s financial situation a current stressor, regardless of the source of income (including criminal activities)?',
  },
  {
    id: '1.8.43b',
    title: 'Reference Text',
    content:
      'Mark Yes if there are three or more address changes in the last year. Do not include a period of incarceration as an address change unless the client did not return to prior address upon release. Record number of address changes within the last twelve months or in the year prior to incarceration in the space provided.',
  },
  {
    id: '1.8.43c',
    title: 'Reference Text',
    content: 'This item has been scored based on the response to item 11.',
  },
  {
    id: '1.8.43d',
    title: 'Reference Text',
    content: 'This item has been scored based on the response to item 12',
  },
  {
    id: '1.8.43e',
    title: 'Reference Text',
    content: 'This item has been scored based on the response to item 14.',
  },
  {
    id: '1.8.43f',
    title: 'Reference Text',
    content:
      'This item is automatically completed based on responses to other items. If item 19 was rated as 0 or 1, then this item is marked Yes.',
  },
  {
    id: '1.8.43g',
    title: 'Reference Text',
    content:
      'This item is automatically completed based on responses to other items. If item 23 was rated as 0 or 1, then this item is marked Yes.',
  },
  {
    id: '1.8.43h',
    title: 'Reference Text',
    content: 'This item has been scored based on the response to item 27.',
  },
  {
    id: '1.8.1.8',
    title: 'Reference Text',
    content:
      'Strength for Antisocial Pattern:\n\nThis subcomponent is probably the most unlikely subcomponent that can be considered a strength because it encompasses a variety of criminogenic factors. The offender must be Very Low or Low (0–1) on this section and must not have more than one other subcomponent in the Moderate to Very High levels (see Section 7 for the offender’s profile; note Section 1 must be scored and the offenders profile plotted in Section 7 before a Strength notation may be assigned here). Having any two sections that are Moderate or higher constitutes a pattern. A possible candidate to receive a Strength notation here is a Very Low or Low risk offender who has great difficulty in dealing with situational specific stress (e.g., loss of employment, death in the family). That is, the offender has a relatively short criminal history and is engaged in prosocial activities until a major life stress event occurs where criminal behavior is seen as a way of coping with the stress (e.g., stealing to gain money after loss of employment or resorting to substance abuse to cope with the grief of a personal loss). Treatment may not require the same intensity and comprehensiveness. The designation of a strength may also be relevant when considering client responsivity because it may be useful to use a client strength in one domain when addressing a criminogenic need in another domain (see Section 9.2.3).',
  },
  {
    id: '2.1.1',
    title: 'Reference Text',
    content:
      'Circle Yes if behavior or circumstances surrounding one or more conditions of probation or conditional release are judged problematic and need to be addressed. This item is similar to, but applies more generally than, item Criminal History #8 (Charge laid, probation breached, or parole suspended during prior community supervision?). Compliance problems with supervision have been documented on more than one occasion. A breach, suspension, or charge during supervision may have occurred, but is not required for the item to be endorsed.',
  },
  {
    id: '2.1.2',
    title: 'Reference Text',
    content:
      'Circle Yes if the files or other reliable sources reveal an official diagnosis of Antisocial Personality Disorder or “psychopathy” by a mental health professional. Particular attention is paid to “psychopathy” rather than a pure behavioral definition of Antisocial Personality Disorder. This item must be circled Yes if there is a documented record of a Psychopathy Checklist–Revised, 2nd Edition (PCL–R 2nd Ed.; Hare, 2003) score of 30 or more. Since there is no universal criterion for psychopathy on the PCL–R assessment, the assessor should also consider circling this item as Yes if there is a PCL–R score of 28 or 29. Note that if this item is Yes, then item  Antisocial Pattern #40 (Specialized assessment for antisocial pattern), must also be Yes.',
  },
  {
    id: '2.1.3',
    title: 'Reference Text',
    content:
      'Circle Yes if files or other reliable sources reveal an official diagnosis of “personality disorder” other than “psychopathy” by a mental health professional. These other personality disorders include the following: Paranoid Personality Disorder, Schizoid Personality Disorder, Schizotypical Personality Disorder, Borderline Personality Disorder, Histrionic Personality Disorder, Narcissistic Personality Disorder, Dependent Personality Disorder, Avoidant Personality Disorder, and Obsessive-Compulsive Personality Disorder.',
  },
  {
    id: '2.1.4',
    title: 'Reference Text',
    content:
      'Circle Yes if some group or person may be a source of serious problems. For example, the activities of an associate, friend or foe, may have negative implications for case management through threat of violence from a third party. This item may apply particularly to adolescents and young adults. A third party, particularly an older person, may be perceived as having disproportionate control or influence over the offender (e.g., pimp or cult leader).',
  },
  {
    id: '2.1.5',
    title: 'Reference Text',
    content:
      'Circle Yes if a pattern of nonreflective, impulsive action is present to a degree that skill training is indicated.',
  },
  {
    id: '2.1.6',
    title: 'Reference Text',
    content:
      'This item may be circled Yes with or without an extensive history of assaultive behavior. There is a pattern of explosiveness, readiness to anger, or attributions of hostile intentions to the actions of others. The offender may be a candidate for anger management training.',
  },
  {
    id: '2.1.7',
    title: 'Reference Text',
    content:
      'This item may be circled Yes with or without an extensive history of assaultive/battering behavior and with or without a history of angry expressions. Circle Yes if an intimidating/controlling style of interpersonal interaction is apparent. This is typically found within intimate and dating relationships. Some level of antibattering programs may be indicated. Circle Yes if there is documented evidence of the offender bullying peers or other children or adolescents at school or in the community. Bullying constitutes physical assault, physical or verbal threats, and verbal or psychological intimidation. Include documented evidence of workplace harassment here.',
  },
  {
    id: '2.1.8',
    title: 'Reference Text',
    content:
      'This item is circled Yes if there is a history of sexual assault (see Section 2.2a - History of Perpetration: Sexual Assault). It may also be circled Yes if concerns, on the part of the offender or others, are detected in the domain of sexual activity, regardless of whether the activity has led to criminal charges (e.g., sexual preoccupation, use of child pornography, use of prostitutes, sexual promiscuity, fetish).',
  },
  {
    id: '2.1.9',
    title: 'Reference Text',
    content:
      'Circle Yes if a specific deficit has been detected or suggested in the domains of personal and/or interpersonal living skills. This item does not include the above-noted domains of self-management or anger management.',
  },
  {
    id: '2.1.10',
    title: 'Reference Text',
    content:
      'Circle Yes if there is an association with significant others (younger or older) that contributes to risk and/ or weakens ties to prosocial others.',
  },
  {
    id: '2.1.11',
    title: 'Reference Text',
    content:
      'Racist/sexist expressions need not be such as to directly promote criminal activity. However, at a minimum, they weaken the quality of ties to home, school, work, and anticriminal others.',
  },
  {
    id: '2.1.12',
    title: 'Reference Text',
    content:
      'Circle Yes if academic and/or vocational functioning is far below where the person could be functioning given his or her personal capabilities.',
  },
  {
    id: '2.1.13',
    title: 'Reference Text',
    content:
      'Circle Yes if there are any additional charges that have not been adjudicated. Outstanding charges may affect case management and treatment planning.',
  },
  {
    id: '2.1.14',
    title: 'Reference Text',
    content:
      'Circle Yes and specify if there is any other circumstance that may heighten the risk of re-offending or weaken prosocial ties.',
  },
  {
    id: '2.2.12',
    title: 'Reference Text',
    content:
      'If this item is circled Yes, then Item 2.1 #7 must also be circled Yes. Also consider scoring Yes for Item 2.1 #11.',
  },
  {
    id: '2.2.15',
    title: 'Reference Text',
    content:
      'If this item is Yes, then Item 1.6 #28 (Alcohol problem, ever) must be Yes. If the problem is current, Item 1.6 #30 (Alcohol problem, currently) must be rated 0 or 1 and Item 1.6 #32 (Law violations) must be circled Yes.',
  },
  {
    id: '2.2.17',
    title: 'Reference Text',
    content:
      'If this item is marked Yes, then consider scoring Procriminal Attitude/Orientation from Section 1. Many white-collar criminals will provide numerous rationalizations and justifications for their crime.',
  },
  {
    id: '2.2.18',
    title: 'Reference Text',
    content:
      'If this item is circled Yes, then Item 1.5 #24 (Some criminal acquaintances) must be circled Yes, and Item 1.5 #25 (Some criminal friends) must be rated 0 or 1.',
  },
  {
    id: '2.2.19',
    title: 'Reference Text',
    content:
      'If this item is circled Yes, then Item 1.5 #24 (Some criminal acquaintances) must be circled Yes, and Item 1.5 #25 (Some criminal friends) must be rated 0 or 1.',
  },
  {
    id: '2.2.20',
    title: 'Reference Text',
    content:
      'If this item is circled Yes, then one may consider circling 0 or 1 for Items 1.7 #36 (Supportive of crime) and 1.7 #37 (Unfavorable toward convention) and Yes for Item 2.1 #11 (Racist/sexist behavior).',
  },
  {
    id: '3.1.7',
    title: 'Reference Text',
    content:
      'Circle Yes if the offender requires a protective custody assignment.',
  },
  {
    id: '3.1.8',
    title: 'Reference Text',
    content: 'List the treatment in the space provided.',
  },
  {
    id: '3.1.9',
    title: 'Reference Text',
    content:
      'Record the number of misconducts in the space provided.\n\nIf this item is circled Yes, then Item 1.1 #7 (ever punished for institutional misconduct or a behavior report?), must also be circled Yes.',
  },
  {
    id: '3.1.10',
    title: 'Reference Text',
    content:
      'Circle Yes if the inmate requires segregation for nondisciplinary reasons. Examples are psychotic, suicidal, or police informant.',
  },
  {
    id: '3.1.11',
    title: 'Reference Text',
    content:
      'If Yes is marked, specify the concerns to the security of the facility posed by the inmate; for example, past involvement in a prison riot, drug smuggling, or predatory behavior toward other inmates.',
  },
  {
    id: '3.2.1',
    title: 'Reference Text',
    content:
      'This item is circled Yes only where specific barriers to release are identified. For example, while in prison, the offender has been extremely disruptive, noncompliant in treatment, or has made threats to people in the community. Specify the reason in the space provided.\n\nNote. Items circled Yes in Section 3.2 may also be noted in Item 1.2 #14 (Suspended or expelled at least once) where it is judged that, for this case, the criminogenic potential is clear and present.',
  },
  {
    id: '3.2.3',
    title: 'Reference Text',
    content:
      'Past or potential media attention may make release to the community untenable at this time.',
  },
  {
    id: '4.1',
    title: 'Reference Text',
    content:
      'See Financial Problems in Item 1.8 #43a (Financial problems). If Item 1.8 #43a (Financial problems) is rated as 0 or 1, score this item as Yes. If Item 1.8 #43a (Financial problems) is rated as 2 or 3, score this item as No.',
  },
  {
    id: '4.2',
    title: 'Reference Text',
    content:
      'Circle Yes if the offender has no fixed address or no regular accommodation. Consider also scoring Items 1.8 #43a and 1.8 #43b.',
  },
  {
    id: '4.3',
    title: 'Reference Text',
    content:
      'Circle Yes if the offender has personal dissatisfaction with accommodation, and/or his or her accommodation conditions may promote association with criminal others.',
  },
  {
    id: '4.4',
    title: 'Reference Text',
    content:
      'Circle Yes if immigration issues are unresolved or a deportation decision has been made. This item is more likely to be circled Yes within a prison setting where immigration “holds” are a concern for inmate placement and management.',
  },
  {
    id: '4.5',
    title: 'Reference Text',
    content:
      'Circle Yes if there are poor monitoring and discipline skills. Difficulties in expressing emotional warmth should also be considered. The offender may require parenting skills training and/or counseling. Include current or past history of children having been removed from the home by a child protection agency.',
  },
  {
    id: '4.6',
    title: 'Reference Text',
    content:
      'Circle Yes if the offender has health problems that have implications for case management concerns (e.g., HIV, AIDS, requires access to medical resources, limits employment).',
  },
  {
    id: '4.7',
    title: 'Reference Text',
    content:
      'Circle Yes if the offender has physical conditions that have implications for case management and/or accommodation in prison (for example, impaired mobility may interfere with gaining access to resources).',
  },
  {
    id: '4.8',
    title: 'Reference Text',
    content:
      'Circle Yes if assessment reveals that a specific learning disability has been suggested to be present by a mental health or educational professional.',
  },
  {
    id: '4.9',
    title: 'Reference Text',
    content:
      'Circle Yes if there is an official diagnosis of Fetal Alcohol Syndrome (FAS) or Fetal Alcohol Effects (FAE) present in the file. Presence of FAS/FAE may interfere with prosocial interactions and independent functioning. Emotional and cognitive deficits may require specialized programs and long-term management.',
  },
  {
    id: '4.10',
    title: 'Reference Text',
    content:
      'Circle Yes if there is an official diagnosis of depression or if feelings of depression are so serious that participation in rewarding anticriminal activities is limited.',
  },
  {
    id: '4.11',
    title: 'Reference Text',
    content:
      'Circle Yes if there is a history of suicide attempts, suggesting that the input of a mental health professional is needed. Professionals may be sought to assist in case management planning.',
  },
  {
    id: '4.12',
    title: 'Reference Text',
    content:
      'Circle Yes if personal distress levels are so high that participation in rewarding anticriminal activities are limited.',
  },
  {
    id: '4.13',
    title: 'Reference Text',
    content:
      'Circle Yes if shyness interferes with participation in rewarding anticriminal activities or group treatment programs.',
  },
  {
    id: '4.14',
    title: 'Reference Text',
    content:
      'Circle Yes if a mental disorder, such as schizophrenia, other psychotic disorder, or mood disorder, as diagnosed by a mental health professional, which is not explicitly criminogenic (recall items in Section 2), but which has implications for case management (e.g., medication, psychiatric involvement) is present.',
  },
  {
    id: '4.15',
    title: 'Reference Text',
    content:
      'Circle Yes if the offender experiences emotional distress of a moderate nature that may interfere with involvement in prosocial activities or create stresses that are relieved by antisocial behavior (specify in the space provided).',
  },
  {
    id: '4.17',
    title: 'Reference Text',
    content:
      'Circle Yes if there is an indication of present or past physical assault from (a) nonfamilial other(s). Case management plans may include victim-oriented services.',
  },
  {
    id: '4.18',
    title: 'Reference Text',
    content:
      'Circle Yes if there is an indication of sexual assault from (a) nonfamilial other(s). Case management plans may include victim-oriented services.',
  },
  {
    id: '4.19',
    title: 'Reference Text',
    content:
      'Circle Yes if there is an indication that the offender was a victim of emotional abuse or presently is a victim of emotional abuse. Note that this item does not require victimization in a family context. Emotional abuse can be committed by teachers, employers, and others in a position of authority or power. Case management plans may include victim-oriented services.',
  },
  {
    id: '4.20',
    title: 'Reference Text',
    content:
      'Circle Yes if there is a history of neglect as a child. If this item is circled Yes, then item 4 #16 (Victim of family violence) must also be circled Yes, and Neglect must be circled. Case management plans may include victim-oriented services.',
  },
  {
    id: '4.20a',
    title: 'Reference Text',
    content:
      'Note here any circumstances not noted earlier, and specify in the space provided.\n\nItems checked in Section 4 may also be noted in Item 2.1 #14 (Other), where it is judged that, for this particular case, the criminogenic potential is clear and present.\n\nAlthough this section is designed as a checklist of the many “other” clinical issues that should be considered and addressed as part of a complete and humane offender case management plan, there is evidence that some of these items have some criminogenic potential (Girard, 1999; Nowicka-Sroga, 2003), as described in chapter 6.',
  },
  {
    id: '5.1',
    title: 'Reference Text',
    content:
      'Motivation to participate actively and meaningfully in a correctional plan may require preparatory programs. Users who are familiar with the transtheoretical model (Prochaska & DiClemente, 1982) and its definitions for various “stages of change” should circle this item Yes if the offender is in the “precontemplative” stage, and possibly if he or she is in the “contemplative” stage.',
  },
  {
    id: '5.2',
    title: 'Reference Text',
    content:
      'Minimization of problems or circumstances may require preparatory programs.',
  },
  {
    id: '5.3',
    title: 'Reference Text',
    content:
      'The interpersonally anxious offender may require types of programs with little confrontation. Consider individual counseling as opposed to group treatment.',
  },
  {
    id: '5.4',
    title: 'Reference Text',
    content:
      'Awareness and sensitivity to women’s issues includes health and mothering concerns. Gender-sensitive treatment and programs are required. If cross-gender victimization is noted, especially Item 4 #16 (victim of family violence), then this item will likely be Yes.',
  },
  {
    id: '5.5',
    title: 'Reference Text',
    content:
      '“Way of life” considerations may suggest culturally specific programs. For example, involvement of elders in Aboriginal (Native American) programs could be considered.',
  },
  {
    id: '5.6',
    title: 'Reference Text',
    content:
      'Strong identifications along ethnic or racial lines may suggest ethnic-sensitive programs. For example, direct attention to dealing with racism could be a program consideration.',
  },
  {
    id: '5.7',
    title: 'Reference Text',
    content:
      'Below-average verbal intelligence may preclude high-level verbal programs. Consider involvement of specific community-based support groups, such as those for the intellectually challenged.',
  },
  {
    id: '5.8',
    title: 'Reference Text',
    content:
      'Language issues and other barriers to communication may have implications for case management. Translation services may be required.',
  },
  {
    id: '5.9',
    title: 'Reference Text',
    content:
      'Although similar in content to Item 4 #14 (Diagnosis of serious mental disorder), which concerns basic mental health services that would be considered as part of a comprehensive case management plan, this item pertains to mental health issues as they impact on one’s efforts to address criminogenic needs. Hence, the presence of a mental disorder may require targeting of noncriminogenic needs along with criminogenic needs.\n\nThis item should be circled Yes if the mental disorder is likely to interfere with one’s efforts to address other criminogenic issues and therefore should be treated first, prior to providing services for a criminogenic problem.\n\nThis item should be circled Yes if the mental disorder is a chronic condition, and efforts to address criminogenic problems must accommodate the offender’s mental health condition (e.g., dual diagnosis of schizophrenia and substance abuse). \n\nIf this item is circled Yes, Item 4 #14 will likely also be circled Yes.',
  },
  {
    id: '5.10',
    title: 'Reference Text',
    content:
      'Although similar in content to Item 2.1 #2 (Diagnosis of “psychopathy”) and Item 2.1 #3 (Diagnosis of other personality disorder), which is considered a specific criminogenic risk/need factor, this item pertains to the extent to which the offender’s personality disorder is likely to impact on efforts to address criminogenic needs. Given current knowledge about the kinds of efforts that are likely to be more successful with these offenders, the mode of intervention may need to be tailored to this specific type of offender. For example, case management plans may require close monitoring and awareness of manipulative behavior that may derail treatment.\n\nIf this item is circled Yes, Item 2.1 #2 and/or Item 2.1 #3 is likely to be circled Yes.',
  },
];

/** ... */
export const data: DataGatherer.Tool = {
  id: 'LS/CMI',
  measureId: '2cc260b6-8840-4d9a-ab7e-3bb4d263ebe1',
  evaluatorId: '79c0f782-f27b-4aec-8c99-d298dd2e0af7',
  version: '0.0.1',
  name: 'LS/CMI',
  references,
  forms: [generalInformationForm, evaluationForm, parts2To7Form],
};
